// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EnterpriseDMS.css - Final Premium Design (Glassmorphism & Dark Mode) */

:root {
    /* Light Theme (Default) */
    --bg-primary: linear-gradient(135deg, #f4f6fc 0%, #e8ecf8 100%);
    --bg-header: rgba(255, 255, 255, 0.4);
    --bg-sidebar: rgba(255, 255, 255, 0.35);
    --bg-sidebar-active: rgba(99, 102, 241, 0.12);
    --bg-card: rgba(255, 255, 255, 0.5);
    --bg-table: rgba(255, 255, 255, 0.5);
    --bg-button-secondary: rgba(255, 255, 255, 0.65);
    --bg-input: rgba(255, 255, 255, 0.4);
    --bg-icon-wrapper: rgba(255, 255, 255, 0.5);

    --text-primary: #1e293b;
    --text-secondary: #475569;
    --text-muted: #64748b;
    --text-accent: #6366f1;

    --border-color: rgba(0, 0, 0, 0.05);
    --border-glass: rgba(255, 255, 255, 0.45);

    --shadow-soft: 0 10px 30px -10px rgba(0, 0, 0, 0.05);
    --shadow-header: 0 8px 24px -10px rgba(0, 0, 0, 0.04);
    --shadow-active: 0 12px 28px -6px rgba(99, 102, 241, 0.15);

    --glass-blur: blur(24px) saturate(180%);
    --primary-gradient: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #ec4899 100%);
    --danger-color: #ef4444;
    --sidebar-width: 280px;
}

html[data-theme='dark'] {
    /* Dark Theme Override */
    --bg-primary: linear-gradient(135deg, #060814 0%, #0d1127 100%);
    --bg-header: rgba(6, 8, 20, 0.5);
    --bg-sidebar: rgba(6, 8, 20, 0.4);
    --bg-sidebar-active: rgba(99, 102, 241, 0.18);
    --bg-card: rgba(20, 26, 48, 0.4);
    --bg-table: rgba(20, 26, 48, 0.35);
    --bg-button-secondary: rgba(15, 22, 42, 0.6);
    --bg-input: rgba(10, 15, 30, 0.55);
    --bg-icon-wrapper: rgba(15, 22, 42, 0.5);

    --text-primary: #ffffff;
    --text-secondary: #f8fafc;
    --text-muted: #cbd5e1;
    --text-accent: #a5b4fc;

    --border-color: rgba(255, 255, 255, 0.05);
    --border-glass: rgba(255, 255, 255, 0.08);

    --shadow-soft: 0 20px 40px -12px rgba(0, 0, 0, 0.5);
    --shadow-header: 0 10px 30px -12px rgba(0, 0, 0, 0.55);
    --shadow-active: 0 15px 35px -8px rgba(99, 102, 241, 0.25);
}

.dms-layout {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: transparent;
    /* Use index.css variables */
    color: var(--text-main);
    font-family: 'Outfit', 'Plus Jakarta Sans', 'Inter', sans-serif;
    transition: background 0.3s ease, color 0.3s ease;
    position: relative;
    overflow: hidden;
}

/* Animated Background matching Dashboard.css */
.dms-layout::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        radial-gradient(circle at 10% 10%, rgba(99, 102, 241, 0.15) 0%, transparent 50%),
        radial-gradient(circle at 90% 90%, rgba(236, 72, 153, 0.1) 0%, transparent 50%);
    z-index: 0;
    pointer-events: none;
}

/* --- Header --- */
.dms-header {
    background: var(--header-bg);
    padding: 0 2.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: var(--glass-border) !important;
    height: 70px;
    z-index: 50;
    backdrop-filter: var(--glass-blur);
    position: sticky;
    top: 0;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2), var(--glass-inner-glow);
}

.header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.menu-trigger {
    background: var(--surface-light);
    border: var(--glass-border);
    padding: 0.6rem;
    border-radius: 12px;
    cursor: pointer;
    color: var(--text-main);
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.menu-trigger:hover {
    background: var(--surface);
    transform: scale(1.05);
}

.platform-name {
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--text-main);
    letter-spacing: -0.02em;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 1.25rem;
}

.theme-toggle-btn {
    background: var(--bg-icon-wrapper);
    border: 1px solid var(--border-color);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 1.2rem;
}

.theme-toggle-btn:hover {
    transform: scale(1.1) rotate(15deg);
    box-shadow: var(--shadow-active);
}

.back-home-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.6rem 1.25rem;
    background: var(--bg-button-secondary);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.2s;
}

.back-home-btn:hover {
    background: var(--bg-icon-wrapper);
    box-shadow: var(--shadow-soft);
    transform: translateY(-1px);
}

/* --- Profile Dropdown --- */
.profile-dropdown-container {
    position: relative;
    display: inline-block;
}

.profile-trigger-btn {
    background: var(--bg-surface, #ffffff);
    border: 1px solid var(--border-color, #e5e7eb);
    border-radius: 8px;
    color: var(--text-main, #1f2937);
    padding: 0.45rem 0.85rem;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
}

html[data-theme='dark'] .profile-trigger-btn {
    background: var(--bg-card, #1a1d2e);
    color: var(--text-primary);
}

.profile-trigger-btn:hover {
    border-color: var(--text-muted, #9ca3af);
}

.profile-dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    background: var(--bg-surface, #ffffff);
    border: 1px solid var(--border-color, #e5e7eb);
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    min-width: 200px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    z-index: 1000;
    padding: 0.5rem;
}

html[data-theme='dark'] .profile-dropdown-menu {
    background: rgba(15, 23, 42, 0.95);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.profile-dropdown-container:hover .profile-dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0.6rem 0.8rem;
    color: var(--text-main, #1f2937);
    text-decoration: none;
    font-size: 0.85rem;
    font-weight: 500;
    border-radius: 8px;
    transition: background 0.2s, color 0.2s;
    cursor: pointer;
    border: none;
    background: transparent;
    width: 100%;
    text-align: left;
}

html[data-theme='dark'] .dropdown-item {
    color: var(--text-secondary);
}

.dropdown-item:hover {
    background: rgba(168, 85, 247, 0.1);
    color: #a855f7;
}

html[data-theme='dark'] .dropdown-item:hover {
    color: #c084fc;
}

/* --- Body --- */
.dms-body {
    display: flex;
    flex: 1 1;
    overflow: hidden;
}

/* --- Sidebar --- */
.dms-sidebar {
    width: var(--sidebar-width);
    background: var(--sidebar-bg);
    border: var(--glass-border) !important;
    margin: 1.25rem 0 1.25rem 1.25rem;
    border-radius: 24px;
    padding: 1.5rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    z-index: 40;
    backdrop-filter: var(--glass-blur);
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
}

html[data-theme='dark'] .dms-sidebar {
    border: 1px solid rgba(168, 85, 247, 0.2) !important;
    box-shadow: 0 0 40px rgba(168, 85, 247, 0.07), var(--glass-shadow), var(--glass-inner-glow);
}

.dms-sidebar.collapsed {
    width: var(--sidebar-collapsed-width);
    padding: 1.5rem 0.5rem;
}

.nav-item {
    display: flex;
    align-items: center;
    padding: 0.8rem 1rem;
    border-radius: 14px;
    cursor: pointer;
    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), background 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
    color: var(--text-secondary);
    font-weight: 600;
    white-space: nowrap;
    gap: 0.75rem;
    border: 1px solid transparent;
    position: relative;
    overflow: hidden;
}

.nav-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%) scaleY(0);
    height: 50%;
    width: 3px;
    background: linear-gradient(135deg, #a855f7, #6366f1);
    border-radius: 0 4px 4px 0;
    transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease;
    opacity: 0;
    box-shadow: 2px 0 8px rgba(168, 85, 247, 0.5);
}

.nav-item.active::before {
    transform: translateY(-50%) scaleY(1);
    opacity: 1;
}

.dms-sidebar.collapsed .nav-item::before {
    left: 2px;
}

.dms-sidebar.collapsed .nav-label {
    display: none;
}

.dms-sidebar.collapsed .nav-item {
    justify-content: center;
    padding: 0.75rem;
    gap: 0;
}

.nav-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    position: relative;
}

/* Unique Icon Colors & Glows matching Dashboard.css */
.connections-icon {
    color: #6366f1;
}

.migrations-icon {
    color: #a855f7;
}

.monitor-icon {
    color: #ec4899;
}

.nav-item:hover .nav-icon,
.nav-item.active .nav-icon {
    background: rgba(255, 255, 255, 0.05);
    transform: scale(1.15) translateY(-1px);
}

.nav-item:hover .connections-icon,
.nav-item.active .connections-icon {
    box-shadow: 0 0 15px rgba(99, 102, 241, 0.3);
}

.nav-item:hover .migrations-icon,
.nav-item.active .migrations-icon {
    box-shadow: 0 0 15px rgba(168, 85, 247, 0.3);
}

.nav-item:hover .monitor-icon,
.nav-item.active .monitor-icon {
    box-shadow: 0 0 15px rgba(236, 72, 153, 0.3);
}

.nav-item:hover {
    background: var(--surface-light);
    border-color: rgba(255, 255, 255, 0.04);
    color: var(--text-main);
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08), var(--glass-inner-glow);
}

.nav-item.active {
    background: linear-gradient(135deg, rgba(168, 85, 247, 0.12) 0%, rgba(99, 102, 241, 0.12) 100%) !important;
    color: var(--text-main) !important;
    border: 1px solid rgba(168, 85, 247, 0.25) !important;
    box-shadow: 0 4px 12px rgba(168, 85, 247, 0.1), var(--glass-inner-glow);
}

/* --- Tab Navigation (Premium Pills) --- */
.tab-navigation {
    display: flex;
    gap: 0.75rem;
    margin-bottom: 2rem;
    padding: 0.5rem;
    background: var(--bg-sidebar);
    border-radius: 16px;
    width: fit-content;
    border: 1px solid var(--border-glass);
}

.nav-tab {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.6rem 1.25rem;
    border-radius: 12px;
    border: 1px solid transparent;
    background: transparent;
    color: var(--text-muted);
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-tab:hover {
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.05);
}

.nav-tab.active {
    background: var(--bg-card);
    color: var(--text-accent);
    border-color: var(--border-glass);
    box-shadow: var(--shadow-soft);
}

.nav-tab .count-badge {
    background: var(--bg-sidebar-active);
    color: var(--text-accent);
    padding: 0.1rem 0.6rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 500;
}

.nav-tab.active .count-badge {
    background: var(--text-accent);
    color: white;
}

/* --- Main Content --- */
.dms-main {
    flex: 1 1;
    padding: 7rem 1.5rem 3rem; /* Increased top padding for Dock */
    overflow-y: auto;
    background: radial-gradient(circle at top center, rgba(99, 102, 241, 0.05), transparent);
    /* Removed z-index to allow fixed overlays to escape stacking context */
}

.breadcrumb {
    font-size: 0.85rem;
    color: var(--text-muted);
    margin-bottom: 2rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.action-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 2.5rem;
}

.header-title-stack {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.action-toolbar h2 {
    font-size: 2.8rem;
    font-weight: 850;
    margin: 0;
    letter-spacing: -0.04em;
    background: var(--gradient-heading);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 1.2;
    padding-top: 0.1em;
    padding-bottom: 0.15em;
}

.header-subtitle {
    margin: 0;
    font-size: 0.95rem;
    color: var(--text-secondary);
    font-weight: 500;
    opacity: 0.8;
}

.add-btn {
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.8) 0%, rgba(168, 85, 247, 0.85) 100%);
    backdrop-filter: var(--glass-blur);
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    color: white;
    padding: 0.8rem 1.75rem;
    border-radius: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    box-shadow: 0 8px 24px -4px rgba(124, 58, 237, 0.3), var(--glass-inner-glow);
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.add-btn:hover {
    transform: translateY(-2px) scale(1.02);
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.9) 0%, rgba(168, 85, 247, 0.95) 100%);
    box-shadow: 0 16px 36px -4px rgba(124, 58, 237, 0.45), 0 0 15px rgba(124, 58, 237, 0.2), var(--glass-inner-glow);
    border-color: rgba(255, 255, 255, 0.25) !important;
}

.add-btn:active {
    transform: translateY(0) scale(0.98);
}

/* --- Connection Cards --- */
.connections-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
    gap: 2rem;
}

.connection-card {
    background: var(--bg-card);
    border-radius: 24px;
    padding: 2.25rem 2rem 2rem;
    border: 1px solid var(--border-glass);
    box-shadow: var(--shadow-soft);
    backdrop-filter: var(--glass-blur);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.connection-card:hover {
    box-shadow: var(--shadow-active);
    transform: translateY(-4px);
}

/* Role-based Tints */
.connection-card.role-source {
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, var(--bg-card) 60%);
    border-top: 4px solid #3b82f6;
}

.connection-card.role-destination {
    background: linear-gradient(135deg, rgba(168, 85, 247, 0.08) 0%, var(--bg-card) 60%);
    border-top: 4px solid #a855f7;
}

.role-label-top {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0.4rem 1rem;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    border-bottom-right-radius: 12px;
    text-transform: uppercase;
    z-index: 10;
}

.role-label-top.role-source {
    background: #3b82f6;
    color: white;
    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.role-label-top.role-destination {
    background: #a855f7;
    color: white;
    box-shadow: 0 2px 4px rgba(168, 85, 247, 0.2);
}

/* Connection Test Visibility */
.connection-card.test-success {
    border: 2px solid #10b981 !important;
    background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, var(--bg-card) 100%) !important;
}

.connection-card.test-failed {
    border: 2px solid #e11d48 !important;
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, var(--bg-card) 100%) !important;
}

.card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 2rem;
}

.card-header-main {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.connection-subtitle {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-top: 0.4rem;
}

.icon-wrapper {
    width: 56px;
    height: 56px;
    background: var(--bg-icon-wrapper);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-color);
}

.icon-wrapper svg {
    color: var(--text-muted);
}

.connection-icon {
    transition: all 0.3s ease;
}

.connection-card:hover .connection-icon {
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(124, 58, 237, 0.15);
}

.name-section h3 {
    font-size: 1.125rem;
    font-weight: 500;
    color: var(--text-primary);
    margin: 0;
    line-height: 1.2;
}

.name-section .type-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.025em;
    margin-top: 0.25rem;
}

.provider-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    background: var(--bg-icon-wrapper);
    border-radius: 6px;
    font-size: 0.7rem;
    font-weight: 500;
    text-transform: uppercase;
    margin-top: 0.75rem;
    color: var(--text-secondary);
}

.role-badge {
    display: inline-block;
    padding: 0.25rem 0.6rem;
    border-radius: 6px;
    font-size: 0.65rem;
    font-weight: 600;
    margin-left: 0.5rem;
}

.role-badge.role-source {
    background: rgba(59, 130, 246, 0.15);
    color: #3b82f6;
}

.role-badge.role-destination {
    background: rgba(168, 85, 247, 0.15);
    color: #a855f7;
}

.provider-badge.aws {
    background: #fff7ed;
    color: #ea580c;
}

.provider-badge.gcp {
    background: #eff6ff;
    color: #2563eb;
}

.card-actions {
    display: flex;
    gap: 0.5rem;
}

.btn-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    border: var(--glass-border) !important;
    background: var(--surface-light);
    backdrop-filter: var(--glass-blur);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    color: var(--text-secondary);
    box-shadow: var(--glass-inner-glow);
}

.btn-icon.test {
    width: auto;
    padding: 0 1.25rem;
    gap: 0.5rem;
    font-size: 0.85rem;
    font-weight: 600;
}

.btn-icon.test:hover {
    background: var(--surface);
    border-color: rgba(255, 255, 255, 0.15) !important;
}

.btn-icon.edit {
    color: var(--text-accent);
}

.btn-icon.delete {
    color: #e11d48;
}

.btn-icon:hover {
    background: var(--surface);
    color: var(--text-main);
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15), var(--glass-inner-glow);
    border-color: rgba(255, 255, 255, 0.15) !important;
}

.btn-icon:active {
    transform: translateY(0);
}

.card-details {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--border-color);
}

.detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.detail-row .label {
    font-size: 0.9rem;
    color: var(--text-muted);
}

.detail-row .value {
    font-size: 0.875rem;
    font-weight: 500;
    font-family: 'JetBrains Mono', 'Consolas', monospace;
    color: var(--text-primary);
}

.card-footer-provider {
    position: absolute;
    bottom: 1.25rem;
    right: 1.5rem;
    display: flex;
    justify-content: flex-end;
}

.provider-pill {
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.65rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border: 1px solid transparent;
    backdrop-filter: blur(4px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* --- Tables --- */
.dms-table-container {
    background: var(--card-bg);
    border-radius: 20px;
    padding: 1.5rem;
    box-shadow: var(--glass-shadow);
    backdrop-filter: var(--glass-blur);
    border: var(--glass-border);
    overflow-x: auto;
}

.dms-table {
    width: 100%;
    border-collapse: collapse;
}

.dms-table th {
    text-align: center;
    padding: 1rem;
    font-size: 0.8rem;
    text-transform: uppercase;
    color: #000000;
    font-weight: bold;
}

html[data-theme='dark'] .dms-table th {
    color: #ffffff;
}

.dms-table td {
    padding: 1.25rem 1rem;
    border-top: 1px solid var(--border-color);
    font-size: 0.95rem;
    color: var(--text-primary);
    text-align: center;
    font-weight: normal;
}

.actions-cell {
    width: auto;
}

.action-stack {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
}

.icon-btn-action {
    height: 30px;
    padding: 0 0.55rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border: 1px solid var(--border-glass);
    background: var(--bg-button-secondary);
    color: var(--text-muted);
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.03em;
}

.icon-btn-action:hover {
    transform: translateY(-2px) scale(1.1);
    color: var(--text-primary);
    box-shadow: var(--shadow-soft);
}

.icon-btn-action.edit:hover {
    color: var(--text-accent);
    border-color: var(--text-accent);
    background: rgba(124, 58, 237, 0.1);
}

.icon-btn-action.delete:hover {
    color: var(--danger-color);
    border-color: var(--danger-color);
    background: rgba(239, 68, 68, 0.1);
}

.icon-btn-action.cutover:hover {
    color: #10b981;
    border-color: #10b981;
    background: rgba(16, 185, 129, 0.1);
}

/* --- Modals --- */
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(5, 7, 16, 0.6);
    backdrop-filter: blur(16px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
}

.modal {
    background: var(--card-bg);
    color: var(--text-primary);
    border-radius: 24px;
    width: 90%;
    max-width: 600px;
    padding: 2.5rem;
    box-shadow: var(--glass-shadow);
    border: var(--glass-border);
    backdrop-filter: var(--glass-blur);
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
    display: flex;
    flex-direction: column;
}

.modal.modal-lg {
    max-width: 800px;
    max-height: 85vh;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    flex-shrink: 0;
}

.modal-header h3 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 500;
}

.modal-close {
    background: transparent;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--text-muted);
    transition: color 0.2s;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}

.modal-close:hover {
    color: var(--text-primary);
    background: var(--bg-icon-wrapper);
}

.modal-body {
    flex: 1 1;
    overflow-y: auto;
    padding-right: 0.5rem;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1rem;
    flex-shrink: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    align-items: center;
}

html[data-theme='light'] .modal-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

/* Save as Draft button — amber-accented glass outlined style */
.btn-save-draft {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    height: 40px;
    padding: 0 1.1rem;
    border-radius: 10px;
    border: 1px solid rgba(251, 191, 36, 0.35);
    background: rgba(251, 191, 36, 0.06);
    color: #fbbf24;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(8px);
    margin-right: auto;
    white-space: nowrap;
}

.btn-save-draft:hover:not(:disabled) {
    background: rgba(251, 191, 36, 0.14);
    border-color: rgba(251, 191, 36, 0.55);
    color: #f59e0b;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(251, 191, 36, 0.15);
}

.btn-save-draft:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

html[data-theme='light'] .btn-save-draft {
    border-color: rgba(217, 119, 6, 0.35);
    background: rgba(217, 119, 6, 0.05);
    color: #b45309;
}

html[data-theme='light'] .btn-save-draft:hover:not(:disabled) {
    background: rgba(217, 119, 6, 0.1);
    border-color: rgba(217, 119, 6, 0.5);
    color: #92400e;
    box-shadow: 0 3px 10px rgba(217, 119, 6, 0.1);
}


.form-group input,
.form-group select {
    width: 100%;
    padding: 0.8rem 1.1rem;
    border-radius: 12px;
    border: var(--glass-border);
    background: var(--bg-input);
    color: var(--text-primary);
    outline: none;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), var(--glass-inner-glow);
    backdrop-filter: blur(4px);
    transition: all 0.25s ease;
}

.form-group input:focus,
.form-group select:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25), var(--glass-inner-glow);
    background: var(--card-hover-bg);
}

/* Role Toggle Buttons */
.role-toggle-group {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.role-toggle-btn {
    flex: 1 1;
    padding: 0.6rem 0.5rem;
    border-radius: 12px;
    border: 1px solid var(--border-glass);
    background: var(--bg-card);
    color: var(--text-muted);
    font-weight: 600;
    font-size: 0.8rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.role-toggle-btn:hover {
    background: var(--bg-card-hover);
    border-color: var(--border-subtle);
}

.role-toggle-btn.active.source {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
    border-color: #3b82f6;
    box-shadow: 0 0 10px rgba(59, 130, 246, 0.1);
}

.role-toggle-btn.active.destination {
    background: rgba(168, 85, 247, 0.1);
    color: #a855f7;
    border-color: #a855f7;
    box-shadow: 0 0 10px rgba(168, 85, 247, 0.1);
}

/* --- Stats Grid --- */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    margin-bottom: 2.5rem;
}

.stat-card {
    background: var(--bg-card);
    padding: 1.5rem;
    border-radius: 16px;
    display: flex;
    align-items: center;
    gap: 1.25rem;
    border: 1px solid var(--border-glass);
    backdrop-filter: var(--glass-blur);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.stat-card:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.2);
}

.stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.stat-icon.total {
    background: rgba(99, 102, 241, 0.1);
    color: #6366f1;
}

.stat-icon.running {
    background: rgba(14, 165, 233, 0.1);
    color: #0ea5e9;
}

.stat-icon.completed {
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
}

.stat-icon.failed {
    background: rgba(239, 68, 68, 0.1);
    color: #e11d48;
}

.stat-icon.cancelled {
    background: rgba(245, 158, 11, 0.1);
    color: #f59e0b;
}

.stat-icon.success {
    background: rgba(168, 85, 247, 0.1);
    color: #a855f7;
}

.stat-icon.data {
    background: rgba(236, 72, 153, 0.1);
    color: #ec4899;
}

.stat-card:hover .stat-icon {
    transform: scale(1.1) rotate(5deg);
}

.stat-info .stat-value {
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--text-primary);
    line-height: 1;
}

.stat-info .stat-label {
    font-size: 0.8rem;
    color: var(--text-muted);
    font-weight: 500;
    margin-top: 0.25rem;
}

/* --- Monitor Details Grid --- */
.monitor-details-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
}

.monitor-card {
    background: var(--bg-card);
    border-radius: 20px;
    border: 1px solid var(--border-glass);
    backdrop-filter: var(--glass-blur);
    display: flex;
    flex-direction: column;
    height: 450px;
    overflow: hidden;
}

.monitor-card-header {
    padding: 1.5rem;
    border-bottom: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.header-title {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.header-icon {
    color: var(--text-accent);
}

.title-group h3 {
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--text-primary);
    margin: 0;
}

.title-group .subtitle {
    font-size: 0.75rem;
    color: var(--text-muted);
}

.job-selector {
    background: var(--bg-input);
    border: 1px solid var(--border-color);
    padding: 0.5rem 1rem;
    border-radius: 8px;
    color: var(--text-primary);
    font-size: 0.85rem;
    outline: none;
}

/* --- Log Viewer --- */
.log-viewer {
    flex: 1 1;
    padding: 1.25rem;
    overflow-y: auto;
    background: rgba(5, 7, 16, 0.75) !important;
    backdrop-filter: blur(16px);
    font-family: 'JetBrains Mono', 'Consolas', monospace;
    font-size: 0.85rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 16px;
    box-shadow: inset 0 3px 12px rgba(0, 0, 0, 0.5);
}

.empty-logs {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--text-muted);
    text-align: center;
    padding: 2rem;
}

.empty-icon {
    opacity: 0.2;
    margin-bottom: 1rem;
}

.log-entry {
    background: transparent !important;
    border: none !important;
    border-bottom: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;
    padding: 0.65rem 0.75rem !important;
    margin-bottom: 0 !important;
    transition: background 0.2s ease !important;
    width: 100% !important;
    box-sizing: border-box !important;
    position: relative !important;
    display: flex !important;
    flex-direction: column !important;
    min-height: fit-content !important;
    border-radius: 0 !important;
}

.log-entry:hover {
    background: rgba(99, 102, 241, 0.04) !important;
}

.log-entry::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    opacity: 0.6;
}

.log-line {
    display: flex !important;
    align-items: center !important;
    gap: 1rem !important;
    width: 100% !important;
}

.log-time {
    color: var(--text-muted, #94a3b8) !important;
    font-size: 0.7rem !important;
    white-space: nowrap !important;
    font-family: 'Outfit', sans-serif !important;
    min-width: 80px !important;
    opacity: 0.7 !important;
    background: transparent !important;
    text-align: left !important;
}

.log-badge {
    padding: 0.15rem 0.45rem !important;
    border-radius: 4px !important;
    font-size: 0.65rem !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    min-width: 55px !important;
    text-align: center !important;
}

.badge-info {
    background: rgba(59, 130, 246, 0.1) !important;
    color: #60a5fa !important;
}

.badge-warn,
.badge-warning {
    background: rgba(245, 158, 11, 0.1) !important;
    color: #fbbf24 !important;
}

.badge-error {
    background: rgba(239, 68, 68, 0.1) !important;
    color: #f87171 !important;
}

.badge-success {
    background: rgba(16, 185, 129, 0.1) !important;
    color: #34d399 !important;
}

.log-msg {
    flex: 1 1 !important;
    color: var(--text-main, #e2e8f0) !important;
    line-height: 1.5 !important;
    font-weight: 400 !important;
    word-break: break-word !important;
    font-size: 0.85rem !important;
}


/* --- Charts Content --- */
.charts-content {
    flex: 1 1;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.chart-wrapper {
    flex: 1 1;
    border-radius: 16px;
    padding: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: var(--surface-light);
    backdrop-filter: var(--glass-blur);
    border: var(--glass-border);
}

.throughput-svg {
    width: 100%;
    height: 100%;
}

.chart-point {
    transition: all 0.3s;
    cursor: help;
}

.chart-point:hover {
    r: 8;
    filter: drop-shadow(0 0 12px var(--primary));
}

.empty-chart {
    text-align: center;
    color: var(--text-muted);
}

.pulse {
    animation: pulse 2s infinite;
    margin-bottom: 1rem;
}

@keyframes pulse {
    0% {
        opacity: 0.4;
        transform: scale(1);
    }

    50% {
        opacity: 0.8;
        transform: scale(1.1);
    }

    100% {
        opacity: 0.4;
        transform: scale(1);
    }
}

/* Transitions */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.connection-card,
.stat-card,
.dms-table-container {
    animation: fadeIn 0.4s ease-out forwards;
}

/* Scrollbar */
::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: var(--text-muted);
    border-radius: 10px;
    opacity: 0.5;
}

::-webkit-scrollbar-thumb:hover {
    background: var(--text-secondary);
}

/* --- Wizard Styling (Nexus Glass) --- */
.wizard-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(12px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
}

.wizard-card {
    background: var(--sidebar-bg);
    border: var(--glass-border);
    border-radius: 36px;
    width: 90%;
    max-width: 900px;
    max-height: 85vh;
    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.5);
    backdrop-filter: var(--glass-blur);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
}

.wizard-header {
    padding: 1.5rem 2rem;
    background: linear-gradient(to right, rgba(124, 58, 237, 0.05), transparent);
    border-bottom: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
}

.wizard-title {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.wizard-title h2 {
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--text-primary);
    margin: 0;
}

.close-btn {
    background: var(--bg-icon-wrapper);
    border: 1px solid var(--border-color);
    color: var(--text-muted);
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.close-btn:hover {
    background: #e11d48;
    border-color: #e11d48;
    color: white;
    transform: rotate(90deg);
}

.wizard-body {
    padding: 2rem;
    overflow-y: auto;
    flex: 1 1;
}

.wiz-step {
    animation: fadeIn 0.4s ease-out;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.wiz-step h3 {
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--text-primary);
    margin-bottom: 0.5rem;
    background: var(--primary-gradient);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.wiz-step p {
    color: var(--text-secondary);
    font-size: 0.95rem;
    line-height: 1.5;
}

.wiz-form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    margin: 1rem 0;
}

.wiz-footer {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--border-color);
}

.dms-btn {
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid var(--border-color);
    background: var(--bg-button-secondary);
    color: var(--text-primary);
}

.dms-btn:hover {
    background: var(--bg-icon-wrapper);
    transform: translateY(-1px);
}

.dms-btn.primary {
    background: var(--primary-gradient);
    color: white;
    border: none;
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
}

.dms-btn.primary:hover {
    box-shadow: 0 8px 16px rgba(124, 58, 237, 0.4);
    transform: translateY(-2px);
}

.dms-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* Step Indicators */
.step-indicator {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 2rem;
}

.step-dot {
    height: 4px;
    flex: 1 1;
    background: var(--border-color);
    border-radius: 2px;
    transition: all 0.3s;
}

.step-dot.active {
    background: var(--text-accent);
}

.step-dot.completed {
    background: #10b981;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* --- Enterprise Blue Bridge Button --- */
.btn-bridge-configure {
    background: #2563eb;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    padding: 10px 20px;
    font-weight: 600;
    font-size: 0.85rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    transition: all 200ms ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: auto;
}

.btn-bridge-configure:hover {
    background: #1d4ed8;
    transform: translateY(-2px);
    box-shadow: 0 6px 8px -1px rgba(0, 0, 0, 0.15), 0 3px 6px -1px rgba(0, 0, 0, 0.1);
}

.btn-bridge-configure:active {
    transform: translateY(0) scale(0.98);
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1);
}

.btn-bridge-configure:focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
}

/* --- Progress & Phase Visibility --- */
.status-cell-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    text-align: center;
}

.mini-progress-track {
    width: 100%;
    height: 4px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    overflow: hidden;
}

.mini-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #7c3aed, #db2777);
    border-radius: 4px;
    transition: width 0.3s ease;
}

.phase-cell {
    font-size: 0.85rem;
    font-weight: normal;
}

.phase-text {
    display: flex;
    align-items: center;
    justify-content: center;
}

.phase-text.replication {
    color: #a855f7;
}

.phase-text.loading {
    color: #3b82f6;
}

.phase-text.pending {
    color: var(--text-muted);
    font-style: italic;
}

.phase-text.success {
    color: #10b981;
}

.status-spinner-mini {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(124, 58, 237, 0.3);
    border-top-color: #7c3aed;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.job-name-link:hover {
    text-decoration: underline;
    opacity: 0.8;
}

.icon-btn-action.monitor:hover {
    color: #ec4899;
    border-color: #ec4899;
    background: rgba(236, 72, 153, 0.1);
}

/* ── Enterprise Job Identity Banner ─────────────────────────────────────── */
.enterprise-job-banner {
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
}

.enterprise-job-identity {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.enterprise-job-name {
    font-size: 1rem;
    font-weight: 500;
    color: var(--text-primary);
}

.enterprise-job-badge {
    display: inline-block;
    padding: 0.2rem 0.6rem;
    border-radius: 4px;
    font-size: 0.65rem;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.06em;
}

.enterprise-job-duration {
    font-size: 0.8rem;
    color: var(--text-secondary);
    display: flex;
    align-items: center;
    gap: 4px;
}

.enterprise-job-hint {
    font-size: 0.75rem;
    color: var(--text-muted);
    font-style: italic;
    margin-left: auto;
}

/* ── Table Progress Bar ─────────────────────────────────────────────────── */
.progress-bar-wrapper {
    height: 6px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    overflow: hidden;
}

.progress-fill {
    height: 100%;
    background: var(--obs-primary, #7c3aed);
    border-radius: 4px;
    transition: width 0.4s ease;
}

.progress-fill.complete {
    background: var(--obs-success, #10b981);
}

/* Shimmer animation for CDC SYNCING rows */
@keyframes shimmer {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.55;
    }

    100% {
        opacity: 1;
    }
}

/* --- Beautified Deletion Modal (Screenshot Match) --- */
.delete-modal-beautified {
    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;
    background: #ffffff;
    border-radius: 35px;
    width: 500px;
    max-width: 95vw;
    padding: 3.5rem 2.5rem 2.5rem;
    position: relative;
    box-shadow: 0 50px 100px rgba(0, 0, 0, 0.15);
    animation: modalPop 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modalPop {
    from {
        transform: scale(0.9) translateY(20px);
        opacity: 0;
    }

    to {
        transform: scale(1) translateY(0);
        opacity: 1;
    }
}

.close-btn-minimal {
    position: absolute;
    top: 1.75rem;
    right: 1.75rem;
    background: #f1f5f9;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s;
}

.close-btn-minimal:hover {
    background: #e2e8f0;
    color: #1e293b;
}

.modal-content-centered {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title-row {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-bottom: 2.5rem;
}

.title-row h2 {
    margin: 0;
    font-size: 1.45rem;
    font-weight: 600;
    color: var(--text-main);
    letter-spacing: -0.01em;
}

.title-icon-red {
    color: #e11d48;
}

.warning-box-modern {
    background: #fff1f2;
    border-radius: 20px;
    padding: 1.5rem;
    display: flex;
    gap: 1.25rem;
    width: 100%;
    margin-bottom: 2.5rem;
    text-align: left;
}

.warning-icon {
    color: #e11d48;
    margin-top: 3px;
}

.warning-text p {
    margin: 0 0 0.25rem 0;
    font-weight: 600;
    color: var(--text-main);
    font-size: 0.92rem;
}

.warning-text span {
    font-size: 0.85rem;
    color: var(--text-secondary);
    line-height: 1.4;
    display: block;
}

.confirm-section-centered {
    width: 100%;
    margin-bottom: 2.5rem;
    text-align: center;
}

.confirm-section-centered label {
    display: block;
    margin-bottom: 0.85rem;
    font-size: 0.82rem;
    font-weight: 500;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.danger-text-highlight {
    color: #e11d48;
    text-decoration: underline;
    text-underline-offset: 3px;
}

.confirm-input-modern {
    width: 100%;
    border: 1.5px solid var(--border-color);
    background: var(--bg-input);
    border-radius: 16px;
    padding: 1.1rem;
    font-size: 0.95rem;
    font-weight: 500;
    text-align: center;
    color: var(--text-main);
    transition: all 0.3s;
}

.confirm-input-modern:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
}

.modal-actions-row {
    display: flex;
    gap: 1rem;
    width: 100%;
}

.btn-secondary-modern,
.btn-danger-modern {
    flex: 1 1;
    padding: 1rem;
    border-radius: 16px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.btn-secondary-modern {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    color: #475569;
}

.btn-secondary-modern:hover {
    background: #f8fafc;
    color: #1e293b;
    border-color: #cbd5e1;
}

/* --- Dark Mode Overrides for Delete Modal --- */
html[data-theme="dark"] .delete-modal-beautified {
    background: #0f172a;
    border: 1px solid rgba(255, 255, 255, 0.05);
    box-shadow: 0 50px 100px rgba(0, 0, 0, 0.4);
}

html[data-theme="dark"] .close-btn-minimal {
    background: rgba(255, 255, 255, 0.05);
    color: #94a3b8;
}

html[data-theme="dark"] .close-btn-minimal:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #f8fafc;
}

html[data-theme="dark"] .warning-box-modern {
    background: rgba(225, 29, 72, 0.1);
    border: 1px solid rgba(225, 29, 72, 0.2);
}

html[data-theme="dark"] .btn-secondary-modern {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #94a3b8;
}

html[data-theme="dark"] .btn-secondary-modern:hover {
    background: rgba(255, 255, 255, 0.08);
    color: #f8fafc;
    border-color: rgba(255, 255, 255, 0.2);
}

.btn-danger-modern {
    border: 1px solid var(--border-color);
    background: var(--bg-button-secondary);
    color: var(--text-muted);
}

.btn-danger-modern.active {
    background: #e11d48;
    color: white;
    border-color: #e11d48;
    box-shadow: 0 10px 20px rgba(225, 29, 72, 0.2);
}

.btn-danger-modern.active:hover {
    background: #be123c;
    transform: translateY(-2px);
    box-shadow: 0 15px 30px rgba(225, 29, 72, 0.3);
}

.jobs-list-minimal {
    max-height: 100px;
    overflow-y: auto;
    margin: 0.5rem 0;
    padding: 0.5rem;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    font-size: 0.85rem;
    color: #475569;
}

.error-notice-minimal {
    width: 100%;
    margin-bottom: 1.5rem;
    padding: 0.75rem 1rem;
    background: #fff1f2;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 0.6rem;
    color: #e11d48;
    font-size: 0.85rem;
    font-weight: 600;
}

/* --- Premium Deletion Modal (Themed Alert System) --- */
.delete-modal-premium {
    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;
    background: var(--background);
    border: var(--glass-border);
    border-radius: 28px;
    width: 480px;
    max-width: 95vw;
    overflow: hidden;
    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.2);
    animation: modalSlideIn 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modalSlideIn {
    from {
        transform: translateY(30px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.modal-header-premium {
    padding: 1.75rem 2rem;
    display: flex;
    align-items: center;
    gap: 1.25rem;
    position: relative;
}

.modal-header-premium.danger {
    background: rgba(239, 68, 68, 0.05);
    border-bottom: 1px solid rgba(239, 68, 68, 0.1);
}

.danger-icon-glow {
    width: 48px;
    height: 48px;
    background: #e11d48;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    box-shadow: 0 8px 16px rgba(239, 68, 68, 0.4);
}

.modal-header-premium h3 {
    margin: 0;
    font-size: 1.35rem;
    font-weight: 500;
    color: var(--text-main);
    letter-spacing: -0.02em;
}

.close-btn-v2 {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
    background: none;
    border: none;
    font-size: 2rem;
    color: var(--text-muted);
    cursor: pointer;
    line-height: 1;
}

.modal-body-premium {
    padding: 2rem;
}

.danger-notice-box {
    background: rgba(239, 68, 68, 0.03);
    border: 1px solid rgba(239, 68, 68, 0.1);
    border-radius: 12px;
    padding: 1.25rem;
    margin-bottom: 2rem;
}

.danger-notice-box p {
    margin: 0 0 0.5rem 0;
    color: var(--text-main);
    font-size: 1.05rem;
    font-weight: 600;
}

.danger-notice-box small {
    display: block;
    color: var(--text-secondary);
    line-height: 1.5;
}

.confirm-input-group-v2 {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.confirm-input-group-v2 label {
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.keyword-danger {
    color: #e11d48;
    /* Rose 600 */
    text-decoration: none;
    border-bottom: 2px solid rgba(225, 29, 72, 0.3);
}

.confirm-input-v2 {
    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;
    width: 100%;
    background: var(--bg-input);
    border: 1.5px solid var(--border-color);
    padding: 1.1rem 1.25rem;
    border-radius: 16px;
    font-size: 1.05rem;
    font-weight: 500;
    color: #e11d48;
    letter-spacing: 0.05em;
    text-align: center;
    transition: all 0.2s;
}

.confirm-input-v2:focus {
    outline: 2px solid #e11d48;
    border-color: transparent;
    background: var(--surface);
}

.error-notice-box {
    margin-top: 1.5rem;
    padding: 1rem;
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid rgba(239, 68, 68, 0.2);
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: #e11d48;
    font-size: 0.88rem;
    font-weight: 600;
}

.modal-footer-premium {
    padding: 1.5rem 2rem 2rem;
    display: flex;
    gap: 1rem;
    background: rgba(0, 0, 0, 0.02);
}

html[data-theme='dark'] .modal-footer-premium {
    background: rgba(255, 255, 255, 0.02);
}

.btn-cancel-premium,
.btn-danger-premium {
    flex: 1 1;
    padding: 1.1rem;
    border-radius: 16px;
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.btn-cancel-premium {
    background: var(--surface-light);
    color: var(--text-secondary);
    border: 1px solid var(--border-color);
}

.btn-cancel-premium:hover {
    background: var(--surface);
    color: var(--text-main);
}

.btn-danger-premium {
    border: none;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.btn-danger-premium.locked {
    background: var(--bg-icon-wrapper);
    color: var(--text-muted);
    cursor: not-allowed;
    opacity: 0.7;
}

.btn-danger-premium.active {
    background: #e11d48;
    color: white;
    box-shadow: 0 10px 25px rgba(225, 29, 72, 0.3);
}

.btn-danger-premium.active:hover {
    background: #dc2626;
    transform: translateY(-2px);
    box-shadow: 0 15px 30px rgba(239, 68, 68, 0.4);
}

.btn-danger-premium.active:active {
    transform: translateY(0);
}

/* --- Sliding Drawer --- */
.drawer-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(4px);
    z-index: 2000;
    display: flex;
    justify-content: flex-end;
    opacity: 0;
    animation: fadeIn 0.3s forwards;
}

@keyframes fadeIn {
    to {
        opacity: 1;
    }
}

.drawer-panel {
    width: 100%;
    max-width: 650px;
    height: 100vh;
    background: var(--bg-primary);
    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.2);
    border-left: 1px solid var(--border-color);
    transform: translateX(100%);
    animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

html[data-theme='dark'] .drawer-panel {
    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.5);
}

@keyframes slideIn {
    to {
        transform: translateX(0);
    }
}

.drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 2rem;
    border-bottom: 1px solid var(--border-glass);
    background: var(--bg-header);
    position: sticky;
    top: 0;
    z-index: 10;
    backdrop-filter: blur(12px);
}

.drawer-title {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 700;
    color: var(--text-primary);
}

.drawer-subtitle {
    margin: 0;
    font-size: 0.85rem;
    color: var(--text-muted);
}

.drawer-close {
    background: var(--bg-icon-wrapper);
    border: 1px solid var(--border-color);
    color: var(--text-muted);
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.drawer-close:hover {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
    border-color: rgba(239, 68, 68, 0.3);
    transform: rotate(90deg);
}

.drawer-content {
    padding: 2rem;
    flex: 1 1;
}

/* --- Beautifications for Migrations List View --- */

.filter-bar {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background: var(--bg-card);
    border: 1px solid var(--border-glass);
    border-radius: 12px;
    padding: 0.6rem 1rem;
    margin-bottom: 1.5rem;
    max-width: 400px;
    box-shadow: var(--shadow-soft);
    backdrop-filter: var(--glass-blur);
    transition: all 0.3s ease;
}

.filter-bar:focus-within {
    border-color: var(--text-accent);
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.15);
}

.filter-bar svg {
    color: var(--text-muted);
}

.filter-bar input {
    background: transparent;
    border: none;
    outline: none;
    color: var(--text-primary);
    font-size: 0.9rem;
    width: 100%;
}

.filter-bar input::placeholder {
    color: var(--text-muted);
    opacity: 0.6;
}

/* Table Hover Interactions & Column Padding */
.dms-table tbody tr {
    transition: background-color 0.2s ease, transform 0.2s ease;
}

.dms-table tbody tr:hover {
    background: rgba(255, 255, 255, 0.02) !important;
}

html[data-theme='light'] .dms-table tbody tr:hover {
    background: rgba(0, 0, 0, 0.015) !important;
}

.checkbox-col {
    width: 45px;
    padding-left: 1.5rem !important;
    text-align: center;
}

.status-col {
    width: 35px;
    padding: 1.25rem 0.5rem !important;
    text-align: center;
}

/* Job Name Link Hover Micro-interaction */
.job-name-link {
    font-weight: normal;
    color: #6366f1;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-block;
    text-decoration: none;
}

.job-name-link:hover {
    color: #818cf8;
    text-decoration: none;
    transform: translateX(3px);
}

/* Connection Cell Wrapper & Badges */
.connection-cell-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-weight: normal;
}

.connection-cell-wrapper .connection-name {
    color: var(--text-primary);
    font-size: 0.9rem;
    font-weight: normal !important;
}

.connection-cell-wrapper .engine-badge {
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    padding: 2px 6px;
    border-radius: 4px;
    background: rgba(99, 102, 241, 0.1);
    color: #818cf8;
    border: 1px solid rgba(99, 102, 241, 0.2);
    letter-spacing: 0.5px;
}

/* Status Capsules */
.status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
    font-size: 0.725rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border: 1px solid transparent;
}

.status-badge.running {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
    border-color: rgba(59, 130, 246, 0.2);
}

.status-badge.completed {
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
    border-color: rgba(16, 185, 129, 0.2);
}

.status-badge.failed {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
    border-color: rgba(239, 68, 68, 0.2);
}

.status-badge.stopped {
    background: rgba(100, 116, 139, 0.1);
    color: #94a3b8;
    border-color: rgba(100, 116, 139, 0.2);
}

.status-badge.pending {
    background: rgba(245, 158, 11, 0.1);
    color: #f59e0b;
    border-color: rgba(245, 158, 11, 0.2);
}

.status-badge.draft {
    background: rgba(168, 85, 247, 0.1);
    color: #a855f7;
    border-color: rgba(168, 85, 247, 0.2);
}

/* Inactive Status Dot */
.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #64748b;
    box-shadow: 0 0 4px rgba(100, 116, 139, 0.4);
    display: inline-block;
}

/* Speed Badge */
.speed-badge {
    margin-left: 8px;
    font-size: 0.725rem;
    font-weight: 600;
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid rgba(16, 185, 129, 0.2);
    display: inline-block;
}

/* --- Premium Beautifications for DMS Migrations Page --- */

/* Custom Checkboxes */
.dms-table input[type="checkbox"],
input[type="checkbox"].dms-checkbox {
    appearance: none !important;
    background-color: var(--bg-input) !important;
    padding: 0 !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    font: inherit !important;
    color: var(--text-accent) !important;
    width: 14px !important;
    height: 14px !important;
    min-width: 14px !important;
    min-height: 14px !important;
    border: 1.5px solid var(--border-color) !important;
    border-radius: 3.5px !important;
    display: inline-grid !important;
    place-content: center !important;
    cursor: pointer !important;
    transition: all 0.2s ease-in-out !important;
}

.dms-table input[type="checkbox"]::before,
input[type="checkbox"].dms-checkbox::before {
    content: "" !important;
    width: 8px !important;
    height: 8px !important;
    transform: scale(0) !important;
    transition: 120ms transform cubic-bezier(0.34, 1.56, 0.64, 1) !important;
    background-color: var(--text-accent) !important;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%) !important;
}

.dms-table input[type="checkbox"]:checked,
input[type="checkbox"].dms-checkbox:checked {
    border-color: var(--text-accent) !important;
    background-color: rgba(124, 58, 237, 0.12) !important;
}

.dms-table input[type="checkbox"]:checked::before,
input[type="checkbox"].dms-checkbox:checked::before {
    transform: scale(1) !important;
}

.dms-table input[type="checkbox"]:focus,
input[type="checkbox"].dms-checkbox:focus {
    outline: none !important;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.15) !important;
}

/* Provider Logo Uniform Frame */
.provider-logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: var(--bg-icon-wrapper);
    border: 1.5px solid var(--border-color);
    padding: 6px;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.provider-logo-container:hover {
    transform: translateY(-1px) scale(1.05);
    border-color: var(--text-accent);
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.1);
}

/* Status Badges Translucency Fix (Overriding Sections.css) */
.dms-table-container .status-badge {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0.35rem 0.85rem !important;
    border-radius: 9999px !important;
    font-size: 0.725rem !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    border: 1.5px solid transparent !important;
    min-width: 95px !important;
    box-shadow: none !important;
    transition: all 0.2s ease !important;
}

.dms-table-container .status-badge.running {
    background: rgba(59, 130, 246, 0.1) !important;
    color: #3b82f6 !important;
    border-color: rgba(59, 130, 246, 0.2) !important;
}

.dms-table-container .status-badge.completed {
    background: rgba(16, 185, 129, 0.1) !important;
    color: #10b981 !important;
    border-color: rgba(16, 185, 129, 0.2) !important;
}

.dms-table-container .status-badge.failed {
    background: rgba(239, 68, 68, 0.1) !important;
    color: #ef4444 !important;
    border-color: rgba(239, 68, 68, 0.2) !important;
}

.dms-table-container .status-badge.stopped {
    background: rgba(100, 116, 139, 0.1) !important;
    color: #64748b !important;
    border-color: rgba(100, 116, 139, 0.2) !important;
}

.dms-table-container .status-badge.pending {
    background: rgba(245, 158, 11, 0.1) !important;
    color: #f59e0b !important;
    border-color: rgba(245, 158, 11, 0.2) !important;
}

.dms-table-container .status-badge.draft {
    background: rgba(168, 85, 247, 0.1) !important;
    color: #a855f7 !important;
    border-color: rgba(168, 85, 247, 0.2) !important;
}

/* Sleek Action Buttons styling */
.dms-table .icon-btn-action {
    height: 32px !important;
    padding: 0 0.95rem !important;
    border-radius: 10px !important;
    font-size: 0.7rem !important;
    font-weight: 700 !important;
    gap: 6px !important;
    border: 1.5px solid transparent !important;
    background: transparent !important;
    color: var(--text-muted) !important;
    box-shadow: none !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.dms-table .icon-btn-action.stop {
    color: #ef4444 !important;
    background: rgba(239, 68, 68, 0.05) !important;
    border-color: rgba(239, 68, 68, 0.12) !important;
}

.dms-table .icon-btn-action.stop:hover {
    color: #ffffff !important;
    background: #ef4444 !important;
    border-color: #ef4444 !important;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2) !important;
    transform: translateY(-1px) !important;
}

.dms-table .icon-btn-action.cutover {
    color: #10b981 !important;
    background: rgba(16, 185, 129, 0.05) !important;
    border-color: rgba(16, 185, 129, 0.12) !important;
}

.dms-table .icon-btn-action.cutover:hover {
    color: #ffffff !important;
    background: #10b981 !important;
    border-color: #10b981 !important;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2) !important;
    transform: translateY(-1px) !important;
}

.dms-table .icon-btn-action.edit {
    color: #a855f7 !important;
    background: rgba(168, 85, 247, 0.05) !important;
    border-color: rgba(168, 85, 247, 0.12) !important;
}

.dms-table .icon-btn-action.edit:hover {
    color: #ffffff !important;
    background: #a855f7 !important;
    border-color: #a855f7 !important;
    box-shadow: 0 4px 12px rgba(168, 85, 247, 0.2) !important;
    transform: translateY(-1px) !important;
}

.dms-table .icon-btn-action.delete {
    color: #ef4444 !important;
    background: rgba(239, 68, 68, 0.05) !important;
    border-color: rgba(239, 68, 68, 0.12) !important;
}

.dms-table .icon-btn-action.delete:hover {
    color: #ffffff !important;
    background: #ef4444 !important;
    border-color: #ef4444 !important;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2) !important;
    transform: translateY(-1px) !important;
}

/* Selected Row Styles */
.dms-table tbody tr.selected {
    background: rgba(99, 102, 241, 0.04) !important;
}

html[data-theme='light'] .dms-table tbody tr.selected {
    background: rgba(99, 102, 241, 0.03) !important;
}

.dms-table tbody tr {
    border-left: 3px solid transparent;
    transition: all 0.2s ease;
}

.dms-table tbody tr.selected {
    border-left: 3px solid var(--text-accent);
}

/* Alignments and spacing */
.dms-table th.checkbox-col,
.dms-table td.checkbox-col {
    text-align: center;
    width: 60px;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}

.dms-table th.status-col,
.dms-table td.status-col {
    text-align: center;
    width: 50px;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}

/* Centering Status Badges Column */
.dms-table th:nth-child(4),
.dms-table td:nth-child(4) {
    text-align: center;
}

.dms-table td:nth-child(4) .status-cell-wrapper {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

/* Centering Actions Column */
.dms-table th.actions-col,
.dms-table td.actions-cell {
    text-align: center;
}

.dms-table td.actions-cell .action-stack {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 100%;
}

/* Header style and spacing */
.dms-table thead {
    background: rgba(0, 0, 0, 0.015);
}

html[data-theme='dark'] .dms-table thead {
    background: rgba(255, 255, 255, 0.01);
}

.dms-table th {
    font-size: 0.75rem;
    font-weight: bold;
    letter-spacing: 0.06em;
    padding: 1.1rem 1rem;
    color: #000000;
    border-bottom: 2px solid var(--border-color);
    text-align: center;
}

html[data-theme="light"] .btn-sq-action.test,
html[data-theme="light"] .btn-test {
    background: rgba(79, 70, 229, 0.12) !important;
    color: #4f46e5 !important;
    border: 1px solid rgba(79, 70, 229, 0.25) !important;
    font-weight: 700 !important;
}

html[data-theme="light"] .btn-sq-action.test:hover,
html[data-theme="light"] .btn-test:hover {
    background: #4f46e5 !important;
    color: white !important;
    border-color: #4f46e5 !important;
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25) !important;
}

html[data-theme="light"] .btn-sq-action.edit,
html[data-theme="light"] .btn-edit-small {
    background: rgba(139, 92, 246, 0.12) !important;
    color: #7c3aed !important;
    border: 1px solid rgba(139, 92, 246, 0.25) !important;
    font-weight: 700 !important;
}

html[data-theme="light"] .btn-sq-action.edit:hover,
html[data-theme="light"] .btn-edit-small:hover {
    background: #7c3aed !important;
    color: white !important;
    border-color: #7c3aed !important;
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.25) !important;
}

html[data-theme="light"] .btn-sq-action.delete,
html[data-theme="light"] .btn-delete-small {
    background: rgba(239, 68, 68, 0.08) !important;
    color: #dc2626 !important;
    border: 1px solid rgba(239, 68, 68, 0.2) !important;
    backdrop-filter: blur(4px) !important;
    font-weight: 700 !important;
}

html[data-theme="light"] .btn-sq-action.delete:hover,
html[data-theme="light"] .btn-delete-small:hover {
    background: #dc2626 !important;
    color: white !important;
    border-color: #dc2626 !important;
    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.25) !important;
}

/* --- Draft Connection Save Button styling --- */
.btn-save-draft {
    background: rgba(245, 158, 11, 0.08) !important;
    border: 1px solid rgba(245, 158, 11, 0.35) !important;
    color: #f59e0b !important;
    font-weight: 700 !important;
    font-size: 0.85rem !important;
    padding: 0.6rem 1.25rem !important;
    border-radius: 10px !important;
    transition: all 0.3s ease !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    cursor: pointer !important;
}

.btn-save-draft:hover {
    background: #f59e0b !important;
    color: white !important;
    border-color: #f59e0b !important;
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.25) !important;
    transform: translateY(-1px) !important;
}

html[data-theme="dark"] .btn-save-draft {
    background: rgba(245, 158, 11, 0.05) !important;
    border: 1px solid rgba(245, 158, 11, 0.45) !important;
    color: #fbbf24 !important;
}

html[data-theme="dark"] .btn-save-draft:hover {
    background: #fbbf24 !important;
    color: #0f172a !important;
    border-color: #fbbf24 !important;
    box-shadow: 0 4px 15px rgba(245, 158, 11, 0.35) !important;
}

/* --- Drafts Badge in Sidebar --- */
.nav-draft-badge {
    margin-left: auto;
    background: linear-gradient(135deg, #a78bfa, #8b5cf6);
    color: #ffffff;
    font-size: 0.72rem;
    font-weight: 700;
    padding: 0.15rem 0.5rem;
    border-radius: 9999px;
    box-shadow: 0 0 10px rgba(167, 139, 250, 0.4);
    min-width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.dms-sidebar.collapsed .nav-draft-badge {
    position: absolute;
    top: 2px;
    right: 2px;
    margin-left: 0;
    font-size: 0.65rem;
    padding: 0.1rem 0.3rem;
    min-width: 14px;
    height: 14px;
}

/* --- Auto-save Toast (Micro-toast) --- */
.autosave-toast {
    position: fixed;
    bottom: 2rem;
    left: 2rem;
    z-index: 9999;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(15, 23, 42, 0.85);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(245, 158, 11, 0.3);
    color: #fbbf24;
    padding: 0.5rem 0.85rem;
    border-radius: 12px;
    font-size: 0.82rem;
    font-weight: 600;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3), 0 0 15px rgba(245, 158, 11, 0.15);
    animation: autosaveToastFadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.autosave-toast-icon {
    color: #fbbf24;
    filter: drop-shadow(0 0 4px rgba(245, 158, 11, 0.5));
}

html[data-theme="light"] .autosave-toast {
    background: rgba(255, 255, 255, 0.9);
    border-color: rgba(245, 158, 11, 0.4);
    color: #d97706;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08), 0 0 12px rgba(245, 158, 11, 0.1);
}

@keyframes autosaveToastFadeIn {
    from {
        opacity: 0;
        transform: translateY(10px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* ==========================================
   Connection Modal Improvements (Solid & High-Contrast)
   ========================================== */

/* Modal overlay: Darker and with reduced backdrop blur (from 16px to 6px) */
.connection-modal-overlay {
    background: rgba(8, 10, 24, 0.82) !important;
    backdrop-filter: blur(6px) !important;
}

/* Light mode overlay override */
html[data-theme='light'] .connection-modal-overlay,
[data-theme='light'] .connection-modal-overlay {
    background: rgba(15, 23, 42, 0.75) !important;
}

/* Connection Modal Card: Almost fully opaque, no backdrop-filter on card itself to prevent double-blur artifacts */
.connection-modal-card {
    background: rgba(20, 26, 48, 0.98) !important;
    backdrop-filter: none !important;
    border: 1px solid rgba(168, 85, 247, 0.25) !important;
    box-shadow: 0 25px 60px -15px rgba(0, 0, 0, 0.8),
        0 0 40px rgba(168, 85, 247, 0.1),
        inset 0 1px 0 0 rgba(255, 255, 255, 0.1) !important;
}

/* Light mode card override */
html[data-theme='light'] .connection-modal-card,
[data-theme='light'] .connection-modal-card {
    background: rgba(255, 255, 255, 0.98) !important;
    border: 1px solid rgba(124, 58, 237, 0.2) !important;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.18),
        0 0 20px rgba(124, 58, 237, 0.05),
        inset 0 1px 0 0 rgba(255, 255, 255, 0.9) !important;
}

/* Input Fields inside connection modal - High-contrast & solid */
.connection-modal-card .form-group input,
.connection-modal-card .form-group select,
.connection-modal-card .form-group textarea {
    background: rgba(10, 12, 24, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    color: #ffffff !important;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.25) !important;
}

.connection-modal-card .form-group input:focus,
.connection-modal-card .form-group select:focus,
.connection-modal-card .form-group textarea:focus {
    background: rgba(15, 20, 38, 0.9) !important;
    border-color: rgba(168, 85, 247, 0.6) !important;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.25), 0 0 12px rgba(168, 85, 247, 0.3) !important;
}

/* Light mode input overrides */
html[data-theme='light'] .connection-modal-card .form-group input,
html[data-theme='light'] .connection-modal-card .form-group select,
html[data-theme='light'] .connection-modal-card .form-group textarea,
[data-theme='light'] .connection-modal-card .form-group input,
[data-theme='light'] .connection-modal-card .form-group select,
[data-theme='light'] .connection-modal-card .form-group textarea {
    background: rgba(248, 250, 252, 0.95) !important;
    border: 1px solid rgba(71, 85, 105, 0.3) !important;
    color: #0f172a !important;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

html[data-theme='light'] .connection-modal-card .form-group input:focus,
html[data-theme='light'] .connection-modal-card .form-group select:focus,
html[data-theme='light'] .connection-modal-card .form-group textarea:focus,
[data-theme='light'] .connection-modal-card .form-group input:focus,
[data-theme='light'] .connection-modal-card .form-group select:focus,
[data-theme='light'] .connection-modal-card .form-group textarea:focus {
    background: #ffffff !important;
    border-color: #7c3aed !important;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 8px rgba(124, 58, 237, 0.2) !important;
}

/* Labels contrast */
.connection-modal-card .form-group label {
    font-weight: 600 !important;
    font-size: 0.85rem !important;
    margin-bottom: 0.5rem !important;
}

html[data-theme='dark'] .connection-modal-card .form-group label,
[data-theme='dark'] .connection-modal-card .form-group label {
    color: #cbd5e1 !important;
}

html[data-theme='light'] .connection-modal-card .form-group label,
[data-theme='light'] .connection-modal-card .form-group label {
    color: #334155 !important;
}

/* Inner headers */
.connection-modal-card h3,
.connection-modal-card h4 {
    font-weight: 700 !important;
}

html[data-theme='dark'] .connection-modal-card h3,
html[data-theme='dark'] .connection-modal-card h4,
[data-theme='dark'] .connection-modal-card h3,
[data-theme='dark'] .connection-modal-card h4 {
    color: #ffffff !important;
}

html[data-theme='light'] .connection-modal-card h3,
html[data-theme='light'] .connection-modal-card h4,
[data-theme='light'] .connection-modal-card h3,
[data-theme='light'] .connection-modal-card h4 {
    color: #0f172a !important;
}

/* ==========================================
   Connection Wizard – Inline Form Inputs
   ========================================== */

/* Wizard inputs / selects / textareas (use inline styles for base,
   CSS only needed for focus rings, option list colors, etc.) */
.conn-wizard-body input,
.conn-wizard-body select,
.conn-wizard-body textarea {
    font-family: inherit;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.conn-wizard-body input:focus,
.conn-wizard-body select:focus,
.conn-wizard-body textarea:focus {
    outline: none;
    border-color: rgba(168, 85, 247, 0.6) !important;
    box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.15) !important;
}

/* Native select option list (dark bg) */
.conn-wizard-body select option {
    background: #1e1e2e;
    color: #f1f5f9;
}

/* Scrollbar for wizard body */
.conn-wizard-scroll::-webkit-scrollbar {
    width: 5px;
}

.conn-wizard-scroll::-webkit-scrollbar-track {
    background: transparent;
}

.conn-wizard-scroll::-webkit-scrollbar-thumb {
    background: rgba(139, 92, 246, 0.3);
    border-radius: 3px;
}

/* --- Shared Unified DMS Page Header --- */
.dms-page-container.dms-page-container {
    padding: 0 0 5rem !important;
    max-width: 1800px !important;
    margin: 0 !important;
    animation: fadeIn 0.4s ease-out;
}

.dms-page-header.dms-page-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 2.5rem !important;
    padding: 0 !important;
    border-bottom: none !important;
    margin: 0 0 2.5rem 0 !important;
}

.dms-page-header .header-title-stack {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.dms-page-header .header-title-stack h2 {
    font-family: 'Outfit', 'Plus Jakarta Sans', 'Inter', sans-serif !important;
    font-size: 2.8rem !important;
    font-weight: 850 !important;
    color: var(--text-main, #f1f5f9) !important;
    margin: 0 !important;
    letter-spacing: -0.04em !important;
    line-height: 1.1 !important;
    background: var(--gradient-heading) !important;
    -webkit-background-clip: text !important;
    background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    text-align: left !important;
}

.dms-page-header .header-subtitle {
    font-family: 'Outfit', 'Plus Jakarta Sans', 'Inter', sans-serif !important;
    margin: 0 !important;
    font-size: 0.95rem !important;
    color: var(--text-secondary, #94a3b8) !important;
    font-weight: 500 !important;
    max-width: 600px !important;
    text-align: left !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/EnterpriseDMS.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;IACI,0BAA0B;IAC1B,+DAA+D;IAC/D,qCAAqC;IACrC,uCAAuC;IACvC,6CAA6C;IAC7C,mCAAmC;IACnC,oCAAoC;IACpC,gDAAgD;IAChD,oCAAoC;IACpC,2CAA2C;;IAE3C,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;;IAEtB,mCAAmC;IACnC,yCAAyC;;IAEzC,oDAAoD;IACpD,qDAAqD;IACrD,0DAA0D;;IAE1D,uCAAuC;IACvC,kFAAkF;IAClF,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,+DAA+D;IAC/D,gCAAgC;IAChC,iCAAiC;IACjC,6CAA6C;IAC7C,gCAAgC;IAChC,kCAAkC;IAClC,4CAA4C;IAC5C,kCAAkC;IAClC,wCAAwC;;IAExC,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;;IAEtB,yCAAyC;IACzC,yCAAyC;;IAEzC,mDAAmD;IACnD,sDAAsD;IACtD,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,+DAA+D;IAC/D,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;uFAEmF;IACnF,UAAU;IACV,oBAAoB;AACxB;;AAEA,mBAAmB;AACnB;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6CAA6C;IAC7C,YAAY;IACZ,WAAW;IACX,kCAAkC;IAClC,gBAAgB;IAChB,MAAM;IACN,kEAAkE;AACtE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,sCAAsC;IACtC,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;IACtC,8CAA8C;IAC9C,kBAAkB;IAClB,gCAAgC;IAChC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,sCAAsC;IACtC,8CAA8C;IAC9C,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,kDAAkD;IAClD,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;IAC1C,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,gCAAgC;IAChC,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,SAAO;IACP,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,sCAAsC;IACtC,iCAAiC;IACjC,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kDAAkD;IAClD,WAAW;IACX,kCAAkC;IAClC,wDAAwD;AAC5D;;AAEA;IACI,oDAAoD;IACpD,2FAA2F;AAC/F;;AAEA;IACI,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gIAAgI;IAChI,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,qCAAqC;IACrC,WAAW;IACX,UAAU;IACV,qDAAqD;IACrD,0BAA0B;IAC1B,2EAA2E;IAC3E,UAAU;IACV,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4DAA4D;IAC5D,kBAAkB;AACtB;;AAEA,sDAAsD;AACtD;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;IAChC,uCAAuC;IACvC,uBAAuB;IACvB,2BAA2B;IAC3B,mEAAmE;AACvE;;AAEA;IACI,0GAA0G;IAC1G,kCAAkC;IAClC,qDAAqD;IACrD,uEAAuE;AAC3E;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,SAAO;IACP,yBAAyB,EAAE,mCAAmC;IAC9D,gBAAgB;IAChB,wFAAwF;IACxF,uEAAuE;AAC3E;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,mCAAmC;IACnC,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,8FAA8F;IAC9F,kCAAkC;IAClC,sDAAsD;IACtD,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,4EAA4E;IAC5E,kDAAkD;AACtD;;AAEA;IACI,uCAAuC;IACvC,8FAA8F;IAC9F,gHAAgH;IAChH,kDAAkD;AACtD;;AAEA;IACI,oCAAoC;AACxC;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,0BAA0B;IAC1B,qCAAqC;IACrC,8BAA8B;IAC9B,kCAAkC;IAClC,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA,qBAAqB;AACrB;IACI,oFAAoF;IACpF,6BAA6B;AACjC;;AAEA;IACI,oFAAoF;IACpF,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;IAChC,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,6CAA6C;AACjD;;AAEA,+BAA+B;AAC/B;IACI,oCAAoC;IACpC,+FAA+F;AACnG;;AAEA;IACI,oCAAoC;IACpC,8FAA8F;AAClG;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;IACtC,gCAAgC;IAChC,kCAAkC;IAClC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mDAAmD;IACnD,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,mEAAmE;IACnE,kDAAkD;AACtD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,oDAAoD;IACpD,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA,mBAAmB;AACnB;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;IACf,+BAA+B;IAC/B,kCAAkC;IAClC,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,qCAAqC;IACrC,sCAAsC;IACtC,wBAAwB;IACxB,eAAe;IACf,4DAA4D;IAC5D,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;IACtC,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,2BAA2B;IAC3B,kCAAkC;IAClC,wDAAwD;IACxD,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,+DAA+D;AAC/D;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kDAAkD;IAClD,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,cAAc;IACd,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,cAAc;IACd,6CAA6C;AACjD;;;AAGA;;IAEI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,aAAa;IACb,wEAAwE;IACxE,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;;IAEI,4BAA4B;IAC5B,uEAAuE;IACvE,gCAAgC;AACpC;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,sBAAsB;IACtB,mBAAmB;IACnB,qCAAqC;IACrC,0BAA0B;IAC1B,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qCAAqC;IACrC,kCAAkC;IAClC,iDAAiD;AACrD;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,qCAAqC;IACrC,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,4CAA4C;IAC5C,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,oBAAoB;IACpB,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;IAC3C,2BAA2B;IAC3B,oDAAoD;IACpD,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,kFAAkF;IAClF,mCAAmC;IACnC,2BAA2B;IAC3B,2CAA2C;IAC3C,sBAAsB;IACtB,iCAAiC;IACjC,6BAA6B;IAC7B,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,4CAA4C;IAC5C,4BAA4B;IAC5B,8BAA8B;IAC9B,4CAA4C;IAC5C,0BAA0B;IAC1B,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;IAC3B,oCAAoC;IACpC,iCAAiC;IACjC,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;;IAEI,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,oBAAkB;IAClB,2CAA2C;IAC3C,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;IACjC,6BAA6B;AACjC;;;AAGA,2BAA2B;AAC3B;IACI,SAAO;IACP,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;IAChC,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,IAAI;IACJ,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA,gBAAgB;AAChB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA,cAAc;AACd;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA,yCAAyC;AACzC;IACI,eAAe;IACf,QAAQ;IACR,iCAAiC;IACjC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;IAC3C,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,4EAA4E;IAC5E,4CAA4C;IAC5C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,mCAAmC;IACnC,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,qCAAqC;IACrC,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAO;IACP,+BAA+B;IAC/B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA,0CAA0C;AAC1C;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iFAAiF;IACjF,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,iFAAiF;AACrF;;AAEA;IACI,oCAAoC;IACpC,6CAA6C;AACjD;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA,8EAA8E;AAC9E;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,8EAA8E;AAC9E;IACI,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,2CAA2C;AAC3C;IACI;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,yDAAyD;AACzD;IACI,sDAAsD;IACtD,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,4CAA4C;IAC5C,sDAAsD;AAC1D;;AAEA;IACI;QACI,sCAAsC;QACtC,UAAU;IACd;;IAEA;QACI,iCAAiC;QACjC,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;;IAEI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,iDAAiD;AACjD;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,sDAAsD;IACtD,6BAA6B;IAC7B,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,2CAA2C;IAC3C,0DAA0D;AAC9D;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;IACI,sDAAsD;IACtD,WAAW;IACX,2BAA2B;IAC3B,uCAAuC;IACvC,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,SAAO;IACP,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;IACxB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,QAAQ;IACR,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,2CAA2C;IAC3C,0CAA0C;IAC1C,2BAA2B;IAC3B,8DAA8D;IAC9D,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;IAC5C,4BAA4B;IAC5B,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAO;AACX;;AAEA,qDAAqD;;AAErD;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;IAC1B,qCAAqC;IACrC,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,8BAA8B;IAC9B,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA,8CAA8C;AAC9C;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA,0CAA0C;AAC1C;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,cAAc;IACd,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,qCAAqC;AACzC;;AAEA,wBAAwB;AACxB;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA,4DAA4D;;AAE5D,sBAAsB;AACtB;;IAGI,2BAA2B;IAC3B,4CAA4C;IAC5C,qBAAqB;IACrB,iCAAiC;IACjC,oBAAoB;IACpB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,kDAAkD;IAClD,+BAA+B;IAC/B,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;;IAEI,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,8BAA8B;IAC9B,wEAAwE;IACxE,+CAA+C;IAC/C,kFAAkF;AACtF;;AAEA;;IAEI,2CAA2C;IAC3C,qDAAqD;AACzD;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,wBAAwB;IACxB,yDAAyD;AAC7D;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,uCAAuC;IACvC,YAAY;IACZ,cAAc;IACd,yCAAyC;IACzC,kDAAkD;AACtD;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;IAChC,8CAA8C;AAClD;;AAEA,6DAA6D;AAC7D;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;IAChC,8BAA8B;IAC9B,2BAA2B;IAC3B,oCAAoC;IACpC,iCAAiC;IACjC,0CAA0C;IAC1C,0BAA0B;IAC1B,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,6CAA6C;IAC7C,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA,iCAAiC;AACjC;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,0CAA0C;IAC1C,kCAAkC;IAClC,mCAAmC;IACnC,2BAA2B;IAC3B,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,gCAAgC;IAChC,wDAAwD;IACxD,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;IAC/C,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,gCAAgC;IAChC,yDAAyD;IACzD,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;IAC/C,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,gCAAgC;IAChC,yDAAyD;IACzD,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,gCAAgC;IAChC,wDAAwD;IACxD,sCAAsC;AAC1C;;AAEA,wBAAwB;AACxB;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,2BAA2B;AAC3B;;IAEI,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA,mCAAmC;AACnC;;IAEI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA,6BAA6B;AAC7B;;IAEI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,WAAW;AACf;;AAEA,6BAA6B;AAC7B;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;IACd,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;;IAEI,8CAA8C;IAC9C,yBAAyB;IACzB,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,uBAAuB;IACvB,gCAAgC;IAChC,yDAAyD;AAC7D;;AAEA;;IAEI,+CAA+C;IAC/C,yBAAyB;IACzB,qDAAqD;IACrD,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,uBAAuB;IACvB,gCAAgC;IAChC,0DAA0D;AAC9D;;AAEA;;IAEI,8CAA8C;IAC9C,yBAAyB;IACzB,mDAAmD;IACnD,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,uBAAuB;IACvB,gCAAgC;IAChC,yDAAyD;AAC7D;;AAEA,iDAAiD;AACjD;IACI,+CAA+C;IAC/C,qDAAqD;IACrD,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,kCAAkC;IAClC,8BAA8B;IAC9B,oCAAoC;IACpC,+BAA+B;IAC/B,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,gCAAgC;IAChC,0DAA0D;IAC1D,sCAAsC;AAC1C;;AAEA;IACI,+CAA+C;IAC/C,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,gCAAgC;IAChC,0DAA0D;AAC9D;;AAEA,oCAAoC;AACpC;IACI,iBAAiB;IACjB,qDAAqD;IACrD,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,6CAA6C;IAC7C,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA,0CAA0C;AAC1C;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kCAAkC;IAClC,2BAA2B;IAC3B,yCAAyC;IACzC,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,6EAA6E;IAC7E,iEAAiE;AACrE;;AAEA;IACI,cAAc;IACd,oDAAoD;AACxD;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,cAAc;IACd,6EAA6E;AACjF;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;;+CAE+C;;AAE/C,4EAA4E;AAC5E;IACI,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA,gCAAgC;AAChC;;IAEI,6CAA6C;AACjD;;AAEA,mHAAmH;AACnH;IACI,6CAA6C;IAC7C,gCAAgC;IAChC,qDAAqD;IACrD;;2DAEuD;AAC3D;;AAEA,6BAA6B;AAC7B;;IAEI,gDAAgD;IAChD,oDAAoD;IACpD;;2DAEuD;AAC3D;;AAEA,iEAAiE;AACjE;;;IAGI,4CAA4C;IAC5C,sDAAsD;IACtD,yBAAyB;IACzB,0DAA0D;AAC9D;;AAEA;;;IAGI,4CAA4C;IAC5C,gDAAgD;IAChD,4FAA4F;AAChG;;AAEA,+BAA+B;AAC/B;;;;;;IAMI,gDAAgD;IAChD,mDAAmD;IACnD,yBAAyB;IACzB,0DAA0D;AAC9D;;AAEA;;;;;;IAMI,8BAA8B;IAC9B,gCAAgC;IAChC,2FAA2F;AAC/F;;AAEA,oBAAoB;AACpB;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;;IAEI,2BAA2B;AAC/B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;+CAE+C;;AAE/C;+DAC+D;AAC/D;;;IAGI,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;;;IAGI,aAAa;IACb,gDAAgD;IAChD,yDAAyD;AAC7D;;AAEA,wCAAwC;AACxC;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA,2CAA2C;AAC3C;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,gCAAgC;IAChC,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,0EAA0E;IAC1E,4BAA4B;IAC5B,2BAA2B;IAC3B,2CAA2C;IAC3C,oBAAoB;IACpB,kCAAkC;IAClC,2BAA2B;IAC3B,8CAA8C;IAC9C,wCAAwC;IACxC,gCAAgC;IAChC,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;IACI,0EAA0E;IAC1E,oBAAoB;IACpB,6BAA6B;IAC7B,gDAAgD;IAChD,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;AAC/B","sourcesContent":["/* EnterpriseDMS.css - Final Premium Design (Glassmorphism & Dark Mode) */\n\n:root {\n    /* Light Theme (Default) */\n    --bg-primary: linear-gradient(135deg, #f4f6fc 0%, #e8ecf8 100%);\n    --bg-header: rgba(255, 255, 255, 0.4);\n    --bg-sidebar: rgba(255, 255, 255, 0.35);\n    --bg-sidebar-active: rgba(99, 102, 241, 0.12);\n    --bg-card: rgba(255, 255, 255, 0.5);\n    --bg-table: rgba(255, 255, 255, 0.5);\n    --bg-button-secondary: rgba(255, 255, 255, 0.65);\n    --bg-input: rgba(255, 255, 255, 0.4);\n    --bg-icon-wrapper: rgba(255, 255, 255, 0.5);\n\n    --text-primary: #1e293b;\n    --text-secondary: #475569;\n    --text-muted: #64748b;\n    --text-accent: #6366f1;\n\n    --border-color: rgba(0, 0, 0, 0.05);\n    --border-glass: rgba(255, 255, 255, 0.45);\n\n    --shadow-soft: 0 10px 30px -10px rgba(0, 0, 0, 0.05);\n    --shadow-header: 0 8px 24px -10px rgba(0, 0, 0, 0.04);\n    --shadow-active: 0 12px 28px -6px rgba(99, 102, 241, 0.15);\n\n    --glass-blur: blur(24px) saturate(180%);\n    --primary-gradient: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #ec4899 100%);\n    --danger-color: #ef4444;\n    --sidebar-width: 280px;\n}\n\nhtml[data-theme='dark'] {\n    /* Dark Theme Override */\n    --bg-primary: linear-gradient(135deg, #060814 0%, #0d1127 100%);\n    --bg-header: rgba(6, 8, 20, 0.5);\n    --bg-sidebar: rgba(6, 8, 20, 0.4);\n    --bg-sidebar-active: rgba(99, 102, 241, 0.18);\n    --bg-card: rgba(20, 26, 48, 0.4);\n    --bg-table: rgba(20, 26, 48, 0.35);\n    --bg-button-secondary: rgba(15, 22, 42, 0.6);\n    --bg-input: rgba(10, 15, 30, 0.55);\n    --bg-icon-wrapper: rgba(15, 22, 42, 0.5);\n\n    --text-primary: #ffffff;\n    --text-secondary: #f8fafc;\n    --text-muted: #cbd5e1;\n    --text-accent: #a5b4fc;\n\n    --border-color: rgba(255, 255, 255, 0.05);\n    --border-glass: rgba(255, 255, 255, 0.08);\n\n    --shadow-soft: 0 20px 40px -12px rgba(0, 0, 0, 0.5);\n    --shadow-header: 0 10px 30px -12px rgba(0, 0, 0, 0.55);\n    --shadow-active: 0 15px 35px -8px rgba(99, 102, 241, 0.25);\n}\n\n.dms-layout {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    background: transparent;\n    /* Use index.css variables */\n    color: var(--text-main);\n    font-family: 'Outfit', 'Plus Jakarta Sans', 'Inter', sans-serif;\n    transition: background 0.3s ease, color 0.3s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n/* Animated Background matching Dashboard.css */\n.dms-layout::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background:\n        radial-gradient(circle at 10% 10%, rgba(99, 102, 241, 0.15) 0%, transparent 50%),\n        radial-gradient(circle at 90% 90%, rgba(236, 72, 153, 0.1) 0%, transparent 50%);\n    z-index: 0;\n    pointer-events: none;\n}\n\n/* --- Header --- */\n.dms-header {\n    background: var(--header-bg);\n    padding: 0 2.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: var(--glass-border) !important;\n    height: 70px;\n    z-index: 50;\n    backdrop-filter: var(--glass-blur);\n    position: sticky;\n    top: 0;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2), var(--glass-inner-glow);\n}\n\n.header-left {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.menu-trigger {\n    background: var(--surface-light);\n    border: var(--glass-border);\n    padding: 0.6rem;\n    border-radius: 12px;\n    cursor: pointer;\n    color: var(--text-main);\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.menu-trigger:hover {\n    background: var(--surface);\n    transform: scale(1.05);\n}\n\n.platform-name {\n    font-size: 1.4rem;\n    font-weight: 600;\n    color: var(--text-main);\n    letter-spacing: -0.02em;\n}\n\n.header-right {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n}\n\n.theme-toggle-btn {\n    background: var(--bg-icon-wrapper);\n    border: 1px solid var(--border-color);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 1.2rem;\n}\n\n.theme-toggle-btn:hover {\n    transform: scale(1.1) rotate(15deg);\n    box-shadow: var(--shadow-active);\n}\n\n.back-home-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.6rem 1.25rem;\n    background: var(--bg-button-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.back-home-btn:hover {\n    background: var(--bg-icon-wrapper);\n    box-shadow: var(--shadow-soft);\n    transform: translateY(-1px);\n}\n\n/* --- Profile Dropdown --- */\n.profile-dropdown-container {\n    position: relative;\n    display: inline-block;\n}\n\n.profile-trigger-btn {\n    background: var(--bg-surface, #ffffff);\n    border: 1px solid var(--border-color, #e5e7eb);\n    border-radius: 8px;\n    color: var(--text-main, #1f2937);\n    padding: 0.45rem 0.85rem;\n    font-size: 0.85rem;\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: all 0.2s ease;\n}\n\nhtml[data-theme='dark'] .profile-trigger-btn {\n    background: var(--bg-card, #1a1d2e);\n    color: var(--text-primary);\n}\n\n.profile-trigger-btn:hover {\n    border-color: var(--text-muted, #9ca3af);\n}\n\n.profile-dropdown-menu {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    margin-top: 8px;\n    background: var(--bg-surface, #ffffff);\n    border: 1px solid var(--border-color, #e5e7eb);\n    border-radius: 12px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n    min-width: 200px;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-10px);\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    z-index: 1000;\n    padding: 0.5rem;\n}\n\nhtml[data-theme='dark'] .profile-dropdown-menu {\n    background: rgba(15, 23, 42, 0.95);\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.6);\n    backdrop-filter: blur(16px);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.profile-dropdown-container:hover .profile-dropdown-menu {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n}\n\n.dropdown-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 0.6rem 0.8rem;\n    color: var(--text-main, #1f2937);\n    text-decoration: none;\n    font-size: 0.85rem;\n    font-weight: 500;\n    border-radius: 8px;\n    transition: background 0.2s, color 0.2s;\n    cursor: pointer;\n    border: none;\n    background: transparent;\n    width: 100%;\n    text-align: left;\n}\n\nhtml[data-theme='dark'] .dropdown-item {\n    color: var(--text-secondary);\n}\n\n.dropdown-item:hover {\n    background: rgba(168, 85, 247, 0.1);\n    color: #a855f7;\n}\n\nhtml[data-theme='dark'] .dropdown-item:hover {\n    color: #c084fc;\n}\n\n/* --- Body --- */\n.dms-body {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n}\n\n/* --- Sidebar --- */\n.dms-sidebar {\n    width: var(--sidebar-width);\n    background: var(--sidebar-bg);\n    border: var(--glass-border) !important;\n    margin: 1.25rem 0 1.25rem 1.25rem;\n    border-radius: 24px;\n    padding: 1.5rem 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    z-index: 40;\n    backdrop-filter: var(--glass-blur);\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n}\n\nhtml[data-theme='dark'] .dms-sidebar {\n    border: 1px solid rgba(168, 85, 247, 0.2) !important;\n    box-shadow: 0 0 40px rgba(168, 85, 247, 0.07), var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.dms-sidebar.collapsed {\n    width: var(--sidebar-collapsed-width);\n    padding: 1.5rem 0.5rem;\n}\n\n.nav-item {\n    display: flex;\n    align-items: center;\n    padding: 0.8rem 1rem;\n    border-radius: 14px;\n    cursor: pointer;\n    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), background 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;\n    color: var(--text-secondary);\n    font-weight: 600;\n    white-space: nowrap;\n    gap: 0.75rem;\n    border: 1px solid transparent;\n    position: relative;\n    overflow: hidden;\n}\n\n.nav-item::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%) scaleY(0);\n    height: 50%;\n    width: 3px;\n    background: linear-gradient(135deg, #a855f7, #6366f1);\n    border-radius: 0 4px 4px 0;\n    transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease;\n    opacity: 0;\n    box-shadow: 2px 0 8px rgba(168, 85, 247, 0.5);\n}\n\n.nav-item.active::before {\n    transform: translateY(-50%) scaleY(1);\n    opacity: 1;\n}\n\n.dms-sidebar.collapsed .nav-item::before {\n    left: 2px;\n}\n\n.dms-sidebar.collapsed .nav-label {\n    display: none;\n}\n\n.dms-sidebar.collapsed .nav-item {\n    justify-content: center;\n    padding: 0.75rem;\n    gap: 0;\n}\n\n.nav-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    position: relative;\n}\n\n/* Unique Icon Colors & Glows matching Dashboard.css */\n.connections-icon {\n    color: #6366f1;\n}\n\n.migrations-icon {\n    color: #a855f7;\n}\n\n.monitor-icon {\n    color: #ec4899;\n}\n\n.nav-item:hover .nav-icon,\n.nav-item.active .nav-icon {\n    background: rgba(255, 255, 255, 0.05);\n    transform: scale(1.15) translateY(-1px);\n}\n\n.nav-item:hover .connections-icon,\n.nav-item.active .connections-icon {\n    box-shadow: 0 0 15px rgba(99, 102, 241, 0.3);\n}\n\n.nav-item:hover .migrations-icon,\n.nav-item.active .migrations-icon {\n    box-shadow: 0 0 15px rgba(168, 85, 247, 0.3);\n}\n\n.nav-item:hover .monitor-icon,\n.nav-item.active .monitor-icon {\n    box-shadow: 0 0 15px rgba(236, 72, 153, 0.3);\n}\n\n.nav-item:hover {\n    background: var(--surface-light);\n    border-color: rgba(255, 255, 255, 0.04);\n    color: var(--text-main);\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08), var(--glass-inner-glow);\n}\n\n.nav-item.active {\n    background: linear-gradient(135deg, rgba(168, 85, 247, 0.12) 0%, rgba(99, 102, 241, 0.12) 100%) !important;\n    color: var(--text-main) !important;\n    border: 1px solid rgba(168, 85, 247, 0.25) !important;\n    box-shadow: 0 4px 12px rgba(168, 85, 247, 0.1), var(--glass-inner-glow);\n}\n\n/* --- Tab Navigation (Premium Pills) --- */\n.tab-navigation {\n    display: flex;\n    gap: 0.75rem;\n    margin-bottom: 2rem;\n    padding: 0.5rem;\n    background: var(--bg-sidebar);\n    border-radius: 16px;\n    width: fit-content;\n    border: 1px solid var(--border-glass);\n}\n\n.nav-tab {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.6rem 1.25rem;\n    border-radius: 12px;\n    border: 1px solid transparent;\n    background: transparent;\n    color: var(--text-muted);\n    font-weight: 600;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.nav-tab:hover {\n    color: var(--text-primary);\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.nav-tab.active {\n    background: var(--bg-card);\n    color: var(--text-accent);\n    border-color: var(--border-glass);\n    box-shadow: var(--shadow-soft);\n}\n\n.nav-tab .count-badge {\n    background: var(--bg-sidebar-active);\n    color: var(--text-accent);\n    padding: 0.1rem 0.6rem;\n    border-radius: 20px;\n    font-size: 0.75rem;\n    font-weight: 500;\n}\n\n.nav-tab.active .count-badge {\n    background: var(--text-accent);\n    color: white;\n}\n\n/* --- Main Content --- */\n.dms-main {\n    flex: 1;\n    padding: 7rem 1.5rem 3rem; /* Increased top padding for Dock */\n    overflow-y: auto;\n    background: radial-gradient(circle at top center, rgba(99, 102, 241, 0.05), transparent);\n    /* Removed z-index to allow fixed overlays to escape stacking context */\n}\n\n.breadcrumb {\n    font-size: 0.85rem;\n    color: var(--text-muted);\n    margin-bottom: 2rem;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.action-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-bottom: 2.5rem;\n}\n\n.header-title-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.action-toolbar h2 {\n    font-size: 2.8rem;\n    font-weight: 850;\n    margin: 0;\n    letter-spacing: -0.04em;\n    background: var(--gradient-heading);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    line-height: 1.2;\n    padding-top: 0.1em;\n    padding-bottom: 0.15em;\n}\n\n.header-subtitle {\n    margin: 0;\n    font-size: 0.95rem;\n    color: var(--text-secondary);\n    font-weight: 500;\n    opacity: 0.8;\n}\n\n.add-btn {\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.8) 0%, rgba(168, 85, 247, 0.85) 100%);\n    backdrop-filter: var(--glass-blur);\n    border: 1px solid rgba(255, 255, 255, 0.15) !important;\n    color: white;\n    padding: 0.8rem 1.75rem;\n    border-radius: 14px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    box-shadow: 0 8px 24px -4px rgba(124, 58, 237, 0.3), var(--glass-inner-glow);\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.add-btn:hover {\n    transform: translateY(-2px) scale(1.02);\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.9) 0%, rgba(168, 85, 247, 0.95) 100%);\n    box-shadow: 0 16px 36px -4px rgba(124, 58, 237, 0.45), 0 0 15px rgba(124, 58, 237, 0.2), var(--glass-inner-glow);\n    border-color: rgba(255, 255, 255, 0.25) !important;\n}\n\n.add-btn:active {\n    transform: translateY(0) scale(0.98);\n}\n\n/* --- Connection Cards --- */\n.connections-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));\n    gap: 2rem;\n}\n\n.connection-card {\n    background: var(--bg-card);\n    border-radius: 24px;\n    padding: 2.25rem 2rem 2rem;\n    border: 1px solid var(--border-glass);\n    box-shadow: var(--shadow-soft);\n    backdrop-filter: var(--glass-blur);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n}\n\n.connection-card:hover {\n    box-shadow: var(--shadow-active);\n    transform: translateY(-4px);\n}\n\n/* Role-based Tints */\n.connection-card.role-source {\n    background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, var(--bg-card) 60%);\n    border-top: 4px solid #3b82f6;\n}\n\n.connection-card.role-destination {\n    background: linear-gradient(135deg, rgba(168, 85, 247, 0.08) 0%, var(--bg-card) 60%);\n    border-top: 4px solid #a855f7;\n}\n\n.role-label-top {\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 0.4rem 1rem;\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n    border-bottom-right-radius: 12px;\n    text-transform: uppercase;\n    z-index: 10;\n}\n\n.role-label-top.role-source {\n    background: #3b82f6;\n    color: white;\n    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);\n}\n\n.role-label-top.role-destination {\n    background: #a855f7;\n    color: white;\n    box-shadow: 0 2px 4px rgba(168, 85, 247, 0.2);\n}\n\n/* Connection Test Visibility */\n.connection-card.test-success {\n    border: 2px solid #10b981 !important;\n    background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, var(--bg-card) 100%) !important;\n}\n\n.connection-card.test-failed {\n    border: 2px solid #e11d48 !important;\n    background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, var(--bg-card) 100%) !important;\n}\n\n.card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 2rem;\n}\n\n.card-header-main {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n.connection-subtitle {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-top: 0.4rem;\n}\n\n.icon-wrapper {\n    width: 56px;\n    height: 56px;\n    background: var(--bg-icon-wrapper);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--border-color);\n}\n\n.icon-wrapper svg {\n    color: var(--text-muted);\n}\n\n.connection-icon {\n    transition: all 0.3s ease;\n}\n\n.connection-card:hover .connection-icon {\n    transform: scale(1.05);\n    box-shadow: 0 0 20px rgba(124, 58, 237, 0.15);\n}\n\n.name-section h3 {\n    font-size: 1.125rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    margin: 0;\n    line-height: 1.2;\n}\n\n.name-section .type-label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.025em;\n    margin-top: 0.25rem;\n}\n\n.provider-badge {\n    display: inline-block;\n    padding: 0.25rem 0.75rem;\n    background: var(--bg-icon-wrapper);\n    border-radius: 6px;\n    font-size: 0.7rem;\n    font-weight: 500;\n    text-transform: uppercase;\n    margin-top: 0.75rem;\n    color: var(--text-secondary);\n}\n\n.role-badge {\n    display: inline-block;\n    padding: 0.25rem 0.6rem;\n    border-radius: 6px;\n    font-size: 0.65rem;\n    font-weight: 600;\n    margin-left: 0.5rem;\n}\n\n.role-badge.role-source {\n    background: rgba(59, 130, 246, 0.15);\n    color: #3b82f6;\n}\n\n.role-badge.role-destination {\n    background: rgba(168, 85, 247, 0.15);\n    color: #a855f7;\n}\n\n.provider-badge.aws {\n    background: #fff7ed;\n    color: #ea580c;\n}\n\n.provider-badge.gcp {\n    background: #eff6ff;\n    color: #2563eb;\n}\n\n.card-actions {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.btn-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    border: var(--glass-border) !important;\n    background: var(--surface-light);\n    backdrop-filter: var(--glass-blur);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    color: var(--text-secondary);\n    box-shadow: var(--glass-inner-glow);\n}\n\n.btn-icon.test {\n    width: auto;\n    padding: 0 1.25rem;\n    gap: 0.5rem;\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.btn-icon.test:hover {\n    background: var(--surface);\n    border-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n.btn-icon.edit {\n    color: var(--text-accent);\n}\n\n.btn-icon.delete {\n    color: #e11d48;\n}\n\n.btn-icon:hover {\n    background: var(--surface);\n    color: var(--text-main);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15), var(--glass-inner-glow);\n    border-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n.btn-icon:active {\n    transform: translateY(0);\n}\n\n.card-details {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid var(--border-color);\n}\n\n.detail-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.detail-row .label {\n    font-size: 0.9rem;\n    color: var(--text-muted);\n}\n\n.detail-row .value {\n    font-size: 0.875rem;\n    font-weight: 500;\n    font-family: 'JetBrains Mono', 'Consolas', monospace;\n    color: var(--text-primary);\n}\n\n.card-footer-provider {\n    position: absolute;\n    bottom: 1.25rem;\n    right: 1.5rem;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.provider-pill {\n    padding: 0.25rem 0.75rem;\n    border-radius: 20px;\n    font-size: 0.65rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    border: 1px solid transparent;\n    backdrop-filter: blur(4px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* --- Tables --- */\n.dms-table-container {\n    background: var(--card-bg);\n    border-radius: 20px;\n    padding: 1.5rem;\n    box-shadow: var(--glass-shadow);\n    backdrop-filter: var(--glass-blur);\n    border: var(--glass-border);\n    overflow-x: auto;\n}\n\n.dms-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.dms-table th {\n    text-align: center;\n    padding: 1rem;\n    font-size: 0.8rem;\n    text-transform: uppercase;\n    color: #000000;\n    font-weight: bold;\n}\n\nhtml[data-theme='dark'] .dms-table th {\n    color: #ffffff;\n}\n\n.dms-table td {\n    padding: 1.25rem 1rem;\n    border-top: 1px solid var(--border-color);\n    font-size: 0.95rem;\n    color: var(--text-primary);\n    text-align: center;\n    font-weight: normal;\n}\n\n.actions-cell {\n    width: auto;\n}\n\n.action-stack {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: center;\n}\n\n.icon-btn-action {\n    height: 30px;\n    padding: 0 0.55rem;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    border: 1px solid var(--border-glass);\n    background: var(--bg-button-secondary);\n    color: var(--text-muted);\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n}\n\n.icon-btn-action:hover {\n    transform: translateY(-2px) scale(1.1);\n    color: var(--text-primary);\n    box-shadow: var(--shadow-soft);\n}\n\n.icon-btn-action.edit:hover {\n    color: var(--text-accent);\n    border-color: var(--text-accent);\n    background: rgba(124, 58, 237, 0.1);\n}\n\n.icon-btn-action.delete:hover {\n    color: var(--danger-color);\n    border-color: var(--danger-color);\n    background: rgba(239, 68, 68, 0.1);\n}\n\n.icon-btn-action.cutover:hover {\n    color: #10b981;\n    border-color: #10b981;\n    background: rgba(16, 185, 129, 0.1);\n}\n\n/* --- Modals --- */\n.modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(5, 7, 16, 0.6);\n    backdrop-filter: blur(16px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n}\n\n.modal {\n    background: var(--card-bg);\n    color: var(--text-primary);\n    border-radius: 24px;\n    width: 90%;\n    max-width: 600px;\n    padding: 2.5rem;\n    box-shadow: var(--glass-shadow);\n    border: var(--glass-border);\n    backdrop-filter: var(--glass-blur);\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n    display: flex;\n    flex-direction: column;\n}\n\n.modal.modal-lg {\n    max-width: 800px;\n    max-height: 85vh;\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    flex-shrink: 0;\n}\n\n.modal-header h3 {\n    margin: 0;\n    font-size: 1.5rem;\n    font-weight: 500;\n}\n\n.modal-close {\n    background: transparent;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: var(--text-muted);\n    transition: color 0.2s;\n    padding: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n}\n\n.modal-close:hover {\n    color: var(--text-primary);\n    background: var(--bg-icon-wrapper);\n}\n\n.modal-body {\n    flex: 1;\n    overflow-y: auto;\n    padding-right: 0.5rem;\n}\n\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-top: 2rem;\n    padding-top: 1rem;\n    flex-shrink: 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n    align-items: center;\n}\n\nhtml[data-theme='light'] .modal-footer {\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n/* Save as Draft button — amber-accented glass outlined style */\n.btn-save-draft {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    height: 40px;\n    padding: 0 1.1rem;\n    border-radius: 10px;\n    border: 1px solid rgba(251, 191, 36, 0.35);\n    background: rgba(251, 191, 36, 0.06);\n    color: #fbbf24;\n    font-size: 0.82rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n    backdrop-filter: blur(8px);\n    margin-right: auto;\n    white-space: nowrap;\n}\n\n.btn-save-draft:hover:not(:disabled) {\n    background: rgba(251, 191, 36, 0.14);\n    border-color: rgba(251, 191, 36, 0.55);\n    color: #f59e0b;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(251, 191, 36, 0.15);\n}\n\n.btn-save-draft:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\nhtml[data-theme='light'] .btn-save-draft {\n    border-color: rgba(217, 119, 6, 0.35);\n    background: rgba(217, 119, 6, 0.05);\n    color: #b45309;\n}\n\nhtml[data-theme='light'] .btn-save-draft:hover:not(:disabled) {\n    background: rgba(217, 119, 6, 0.1);\n    border-color: rgba(217, 119, 6, 0.5);\n    color: #92400e;\n    box-shadow: 0 3px 10px rgba(217, 119, 6, 0.1);\n}\n\n\n.form-group input,\n.form-group select {\n    width: 100%;\n    padding: 0.8rem 1.1rem;\n    border-radius: 12px;\n    border: var(--glass-border);\n    background: var(--bg-input);\n    color: var(--text-primary);\n    outline: none;\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), var(--glass-inner-glow);\n    backdrop-filter: blur(4px);\n    transition: all 0.25s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25), var(--glass-inner-glow);\n    background: var(--card-hover-bg);\n}\n\n/* Role Toggle Buttons */\n.role-toggle-group {\n    display: flex;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n}\n\n.role-toggle-btn {\n    flex: 1;\n    padding: 0.6rem 0.5rem;\n    border-radius: 12px;\n    border: 1px solid var(--border-glass);\n    background: var(--bg-card);\n    color: var(--text-muted);\n    font-weight: 600;\n    font-size: 0.8rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.role-toggle-btn:hover {\n    background: var(--bg-card-hover);\n    border-color: var(--border-subtle);\n}\n\n.role-toggle-btn.active.source {\n    background: rgba(59, 130, 246, 0.1);\n    color: #3b82f6;\n    border-color: #3b82f6;\n    box-shadow: 0 0 10px rgba(59, 130, 246, 0.1);\n}\n\n.role-toggle-btn.active.destination {\n    background: rgba(168, 85, 247, 0.1);\n    color: #a855f7;\n    border-color: #a855f7;\n    box-shadow: 0 0 10px rgba(168, 85, 247, 0.1);\n}\n\n/* --- Stats Grid --- */\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1.5rem;\n    margin-bottom: 2.5rem;\n}\n\n.stat-card {\n    background: var(--bg-card);\n    padding: 1.5rem;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    border: 1px solid var(--border-glass);\n    backdrop-filter: var(--glass-blur);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.stat-card:hover {\n    transform: translateY(-5px) scale(1.02);\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.2);\n}\n\n.stat-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n}\n\n.stat-icon.total {\n    background: rgba(99, 102, 241, 0.1);\n    color: #6366f1;\n}\n\n.stat-icon.running {\n    background: rgba(14, 165, 233, 0.1);\n    color: #0ea5e9;\n}\n\n.stat-icon.completed {\n    background: rgba(16, 185, 129, 0.1);\n    color: #10b981;\n}\n\n.stat-icon.failed {\n    background: rgba(239, 68, 68, 0.1);\n    color: #e11d48;\n}\n\n.stat-icon.cancelled {\n    background: rgba(245, 158, 11, 0.1);\n    color: #f59e0b;\n}\n\n.stat-icon.success {\n    background: rgba(168, 85, 247, 0.1);\n    color: #a855f7;\n}\n\n.stat-icon.data {\n    background: rgba(236, 72, 153, 0.1);\n    color: #ec4899;\n}\n\n.stat-card:hover .stat-icon {\n    transform: scale(1.1) rotate(5deg);\n}\n\n.stat-info .stat-value {\n    font-size: 1.5rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    line-height: 1;\n}\n\n.stat-info .stat-label {\n    font-size: 0.8rem;\n    color: var(--text-muted);\n    font-weight: 500;\n    margin-top: 0.25rem;\n}\n\n/* --- Monitor Details Grid --- */\n.monitor-details-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n}\n\n.monitor-card {\n    background: var(--bg-card);\n    border-radius: 20px;\n    border: 1px solid var(--border-glass);\n    backdrop-filter: var(--glass-blur);\n    display: flex;\n    flex-direction: column;\n    height: 450px;\n    overflow: hidden;\n}\n\n.monitor-card-header {\n    padding: 1.5rem;\n    border-bottom: 1px solid var(--border-color);\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.header-title {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n}\n\n.header-icon {\n    color: var(--text-accent);\n}\n\n.title-group h3 {\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    margin: 0;\n}\n\n.title-group .subtitle {\n    font-size: 0.75rem;\n    color: var(--text-muted);\n}\n\n.job-selector {\n    background: var(--bg-input);\n    border: 1px solid var(--border-color);\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    color: var(--text-primary);\n    font-size: 0.85rem;\n    outline: none;\n}\n\n/* --- Log Viewer --- */\n.log-viewer {\n    flex: 1;\n    padding: 1.25rem;\n    overflow-y: auto;\n    background: rgba(5, 7, 16, 0.75) !important;\n    backdrop-filter: blur(16px);\n    font-family: 'JetBrains Mono', 'Consolas', monospace;\n    font-size: 0.85rem;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 16px;\n    box-shadow: inset 0 3px 12px rgba(0, 0, 0, 0.5);\n}\n\n.empty-logs {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-muted);\n    text-align: center;\n    padding: 2rem;\n}\n\n.empty-icon {\n    opacity: 0.2;\n    margin-bottom: 1rem;\n}\n\n.log-entry {\n    background: transparent !important;\n    border: none !important;\n    border-bottom: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;\n    padding: 0.65rem 0.75rem !important;\n    margin-bottom: 0 !important;\n    transition: background 0.2s ease !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n    position: relative !important;\n    display: flex !important;\n    flex-direction: column !important;\n    min-height: fit-content !important;\n    border-radius: 0 !important;\n}\n\n.log-entry:hover {\n    background: rgba(99, 102, 241, 0.04) !important;\n}\n\n.log-entry::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 3px;\n    opacity: 0.6;\n}\n\n.log-line {\n    display: flex !important;\n    align-items: center !important;\n    gap: 1rem !important;\n    width: 100% !important;\n}\n\n.log-time {\n    color: var(--text-muted, #94a3b8) !important;\n    font-size: 0.7rem !important;\n    white-space: nowrap !important;\n    font-family: 'Outfit', sans-serif !important;\n    min-width: 80px !important;\n    opacity: 0.7 !important;\n    background: transparent !important;\n    text-align: left !important;\n}\n\n.log-badge {\n    padding: 0.15rem 0.45rem !important;\n    border-radius: 4px !important;\n    font-size: 0.65rem !important;\n    font-weight: 700 !important;\n    text-transform: uppercase !important;\n    letter-spacing: 0.05em !important;\n    min-width: 55px !important;\n    text-align: center !important;\n}\n\n.badge-info {\n    background: rgba(59, 130, 246, 0.1) !important;\n    color: #60a5fa !important;\n}\n\n.badge-warn,\n.badge-warning {\n    background: rgba(245, 158, 11, 0.1) !important;\n    color: #fbbf24 !important;\n}\n\n.badge-error {\n    background: rgba(239, 68, 68, 0.1) !important;\n    color: #f87171 !important;\n}\n\n.badge-success {\n    background: rgba(16, 185, 129, 0.1) !important;\n    color: #34d399 !important;\n}\n\n.log-msg {\n    flex: 1 !important;\n    color: var(--text-main, #e2e8f0) !important;\n    line-height: 1.5 !important;\n    font-weight: 400 !important;\n    word-break: break-word !important;\n    font-size: 0.85rem !important;\n}\n\n\n/* --- Charts Content --- */\n.charts-content {\n    flex: 1;\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.chart-wrapper {\n    flex: 1;\n    border-radius: 16px;\n    padding: 1.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    background: var(--surface-light);\n    backdrop-filter: var(--glass-blur);\n    border: var(--glass-border);\n}\n\n.throughput-svg {\n    width: 100%;\n    height: 100%;\n}\n\n.chart-point {\n    transition: all 0.3s;\n    cursor: help;\n}\n\n.chart-point:hover {\n    r: 8;\n    filter: drop-shadow(0 0 12px var(--primary));\n}\n\n.empty-chart {\n    text-align: center;\n    color: var(--text-muted);\n}\n\n.pulse {\n    animation: pulse 2s infinite;\n    margin-bottom: 1rem;\n}\n\n@keyframes pulse {\n    0% {\n        opacity: 0.4;\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 0.8;\n        transform: scale(1.1);\n    }\n\n    100% {\n        opacity: 0.4;\n        transform: scale(1);\n    }\n}\n\n/* Transitions */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.connection-card,\n.stat-card,\n.dms-table-container {\n    animation: fadeIn 0.4s ease-out forwards;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n    width: 8px;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n    background: var(--text-muted);\n    border-radius: 10px;\n    opacity: 0.5;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: var(--text-secondary);\n}\n\n/* --- Wizard Styling (Nexus Glass) --- */\n.wizard-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.4);\n    backdrop-filter: blur(12px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 200;\n}\n\n.wizard-card {\n    background: var(--sidebar-bg);\n    border: var(--glass-border);\n    border-radius: 36px;\n    width: 90%;\n    max-width: 900px;\n    max-height: 85vh;\n    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.5);\n    backdrop-filter: var(--glass-blur);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    position: relative;\n}\n\n.wizard-header {\n    padding: 1.5rem 2rem;\n    background: linear-gradient(to right, rgba(124, 58, 237, 0.05), transparent);\n    border-bottom: 1px solid var(--border-color);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.wizard-title {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.wizard-title h2 {\n    font-size: 1.5rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    margin: 0;\n}\n\n.close-btn {\n    background: var(--bg-icon-wrapper);\n    border: 1px solid var(--border-color);\n    color: var(--text-muted);\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.close-btn:hover {\n    background: #e11d48;\n    border-color: #e11d48;\n    color: white;\n    transform: rotate(90deg);\n}\n\n.wizard-body {\n    padding: 2rem;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.wiz-step {\n    animation: fadeIn 0.4s ease-out;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.wiz-step h3 {\n    font-size: 1.5rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    margin-bottom: 0.5rem;\n    background: var(--primary-gradient);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.wiz-step p {\n    color: var(--text-secondary);\n    font-size: 0.95rem;\n    line-height: 1.5;\n}\n\n.wiz-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n    margin: 1rem 0;\n}\n\n.wiz-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-top: 2rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid var(--border-color);\n}\n\n.dms-btn {\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-weight: 600;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: all 0.2s;\n    border: 1px solid var(--border-color);\n    background: var(--bg-button-secondary);\n    color: var(--text-primary);\n}\n\n.dms-btn:hover {\n    background: var(--bg-icon-wrapper);\n    transform: translateY(-1px);\n}\n\n.dms-btn.primary {\n    background: var(--primary-gradient);\n    color: white;\n    border: none;\n    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);\n}\n\n.dms-btn.primary:hover {\n    box-shadow: 0 8px 16px rgba(124, 58, 237, 0.4);\n    transform: translateY(-2px);\n}\n\n.dms-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n/* Step Indicators */\n.step-indicator {\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 2rem;\n}\n\n.step-dot {\n    height: 4px;\n    flex: 1;\n    background: var(--border-color);\n    border-radius: 2px;\n    transition: all 0.3s;\n}\n\n.step-dot.active {\n    background: var(--text-accent);\n}\n\n.step-dot.completed {\n    background: #10b981;\n}\n\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px) scale(0.95);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n/* --- Enterprise Blue Bridge Button --- */\n.btn-bridge-configure {\n    background: #2563eb;\n    color: #ffffff;\n    border: none;\n    border-radius: 8px;\n    padding: 10px 20px;\n    font-weight: 600;\n    font-size: 0.85rem;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n    cursor: pointer;\n    transition: all 200ms ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: auto;\n}\n\n.btn-bridge-configure:hover {\n    background: #1d4ed8;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 8px -1px rgba(0, 0, 0, 0.15), 0 3px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.btn-bridge-configure:active {\n    transform: translateY(0) scale(0.98);\n    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1);\n}\n\n.btn-bridge-configure:focus-visible {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n}\n\n/* --- Progress & Phase Visibility --- */\n.status-cell-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: center;\n    text-align: center;\n}\n\n.mini-progress-track {\n    width: 100%;\n    height: 4px;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.mini-progress-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #7c3aed, #db2777);\n    border-radius: 4px;\n    transition: width 0.3s ease;\n}\n\n.phase-cell {\n    font-size: 0.85rem;\n    font-weight: normal;\n}\n\n.phase-text {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.phase-text.replication {\n    color: #a855f7;\n}\n\n.phase-text.loading {\n    color: #3b82f6;\n}\n\n.phase-text.pending {\n    color: var(--text-muted);\n    font-style: italic;\n}\n\n.phase-text.success {\n    color: #10b981;\n}\n\n.status-spinner-mini {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(124, 58, 237, 0.3);\n    border-top-color: #7c3aed;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.job-name-link:hover {\n    text-decoration: underline;\n    opacity: 0.8;\n}\n\n.icon-btn-action.monitor:hover {\n    color: #ec4899;\n    border-color: #ec4899;\n    background: rgba(236, 72, 153, 0.1);\n}\n\n/* ── Enterprise Job Identity Banner ─────────────────────────────────────── */\n.enterprise-job-banner {\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    padding: 0.75rem 1.25rem;\n    margin-bottom: 1rem;\n}\n\n.enterprise-job-identity {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n}\n\n.enterprise-job-name {\n    font-size: 1rem;\n    font-weight: 500;\n    color: var(--text-primary);\n}\n\n.enterprise-job-badge {\n    display: inline-block;\n    padding: 0.2rem 0.6rem;\n    border-radius: 4px;\n    font-size: 0.65rem;\n    font-weight: 600;\n    color: #fff;\n    letter-spacing: 0.06em;\n}\n\n.enterprise-job-duration {\n    font-size: 0.8rem;\n    color: var(--text-secondary);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.enterprise-job-hint {\n    font-size: 0.75rem;\n    color: var(--text-muted);\n    font-style: italic;\n    margin-left: auto;\n}\n\n/* ── Table Progress Bar ─────────────────────────────────────────────────── */\n.progress-bar-wrapper {\n    height: 6px;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.progress-fill {\n    height: 100%;\n    background: var(--obs-primary, #7c3aed);\n    border-radius: 4px;\n    transition: width 0.4s ease;\n}\n\n.progress-fill.complete {\n    background: var(--obs-success, #10b981);\n}\n\n/* Shimmer animation for CDC SYNCING rows */\n@keyframes shimmer {\n    0% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.55;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n/* --- Beautified Deletion Modal (Screenshot Match) --- */\n.delete-modal-beautified {\n    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;\n    background: #ffffff;\n    border-radius: 35px;\n    width: 500px;\n    max-width: 95vw;\n    padding: 3.5rem 2.5rem 2.5rem;\n    position: relative;\n    box-shadow: 0 50px 100px rgba(0, 0, 0, 0.15);\n    animation: modalPop 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes modalPop {\n    from {\n        transform: scale(0.9) translateY(20px);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1) translateY(0);\n        opacity: 1;\n    }\n}\n\n.close-btn-minimal {\n    position: absolute;\n    top: 1.75rem;\n    right: 1.75rem;\n    background: #f1f5f9;\n    border: none;\n    width: 32px;\n    height: 32px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.close-btn-minimal:hover {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.modal-content-centered {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.title-row {\n    display: flex;\n    align-items: center;\n    gap: 0.8rem;\n    margin-bottom: 2.5rem;\n}\n\n.title-row h2 {\n    margin: 0;\n    font-size: 1.45rem;\n    font-weight: 600;\n    color: var(--text-main);\n    letter-spacing: -0.01em;\n}\n\n.title-icon-red {\n    color: #e11d48;\n}\n\n.warning-box-modern {\n    background: #fff1f2;\n    border-radius: 20px;\n    padding: 1.5rem;\n    display: flex;\n    gap: 1.25rem;\n    width: 100%;\n    margin-bottom: 2.5rem;\n    text-align: left;\n}\n\n.warning-icon {\n    color: #e11d48;\n    margin-top: 3px;\n}\n\n.warning-text p {\n    margin: 0 0 0.25rem 0;\n    font-weight: 600;\n    color: var(--text-main);\n    font-size: 0.92rem;\n}\n\n.warning-text span {\n    font-size: 0.85rem;\n    color: var(--text-secondary);\n    line-height: 1.4;\n    display: block;\n}\n\n.confirm-section-centered {\n    width: 100%;\n    margin-bottom: 2.5rem;\n    text-align: center;\n}\n\n.confirm-section-centered label {\n    display: block;\n    margin-bottom: 0.85rem;\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.danger-text-highlight {\n    color: #e11d48;\n    text-decoration: underline;\n    text-underline-offset: 3px;\n}\n\n.confirm-input-modern {\n    width: 100%;\n    border: 1.5px solid var(--border-color);\n    background: var(--bg-input);\n    border-radius: 16px;\n    padding: 1.1rem;\n    font-size: 0.95rem;\n    font-weight: 500;\n    text-align: center;\n    color: var(--text-main);\n    transition: all 0.3s;\n}\n\n.confirm-input-modern:focus {\n    outline: none;\n    border-color: #6366f1;\n    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);\n}\n\n.modal-actions-row {\n    display: flex;\n    gap: 1rem;\n    width: 100%;\n}\n\n.btn-secondary-modern,\n.btn-danger-modern {\n    flex: 1;\n    padding: 1rem;\n    border-radius: 16px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.btn-secondary-modern {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    color: #475569;\n}\n\n.btn-secondary-modern:hover {\n    background: #f8fafc;\n    color: #1e293b;\n    border-color: #cbd5e1;\n}\n\n/* --- Dark Mode Overrides for Delete Modal --- */\nhtml[data-theme=\"dark\"] .delete-modal-beautified {\n    background: #0f172a;\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    box-shadow: 0 50px 100px rgba(0, 0, 0, 0.4);\n}\n\nhtml[data-theme=\"dark\"] .close-btn-minimal {\n    background: rgba(255, 255, 255, 0.05);\n    color: #94a3b8;\n}\n\nhtml[data-theme=\"dark\"] .close-btn-minimal:hover {\n    background: rgba(255, 255, 255, 0.1);\n    color: #f8fafc;\n}\n\nhtml[data-theme=\"dark\"] .warning-box-modern {\n    background: rgba(225, 29, 72, 0.1);\n    border: 1px solid rgba(225, 29, 72, 0.2);\n}\n\nhtml[data-theme=\"dark\"] .btn-secondary-modern {\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    color: #94a3b8;\n}\n\nhtml[data-theme=\"dark\"] .btn-secondary-modern:hover {\n    background: rgba(255, 255, 255, 0.08);\n    color: #f8fafc;\n    border-color: rgba(255, 255, 255, 0.2);\n}\n\n.btn-danger-modern {\n    border: 1px solid var(--border-color);\n    background: var(--bg-button-secondary);\n    color: var(--text-muted);\n}\n\n.btn-danger-modern.active {\n    background: #e11d48;\n    color: white;\n    border-color: #e11d48;\n    box-shadow: 0 10px 20px rgba(225, 29, 72, 0.2);\n}\n\n.btn-danger-modern.active:hover {\n    background: #be123c;\n    transform: translateY(-2px);\n    box-shadow: 0 15px 30px rgba(225, 29, 72, 0.3);\n}\n\n.jobs-list-minimal {\n    max-height: 100px;\n    overflow-y: auto;\n    margin: 0.5rem 0;\n    padding: 0.5rem;\n    background: rgba(0, 0, 0, 0.03);\n    border-radius: 8px;\n    font-size: 0.85rem;\n    color: #475569;\n}\n\n.error-notice-minimal {\n    width: 100%;\n    margin-bottom: 1.5rem;\n    padding: 0.75rem 1rem;\n    background: #fff1f2;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    color: #e11d48;\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n/* --- Premium Deletion Modal (Themed Alert System) --- */\n.delete-modal-premium {\n    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;\n    background: var(--background);\n    border: var(--glass-border);\n    border-radius: 28px;\n    width: 480px;\n    max-width: 95vw;\n    overflow: hidden;\n    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.2);\n    animation: modalSlideIn 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes modalSlideIn {\n    from {\n        transform: translateY(30px);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.modal-header-premium {\n    padding: 1.75rem 2rem;\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    position: relative;\n}\n\n.modal-header-premium.danger {\n    background: rgba(239, 68, 68, 0.05);\n    border-bottom: 1px solid rgba(239, 68, 68, 0.1);\n}\n\n.danger-icon-glow {\n    width: 48px;\n    height: 48px;\n    background: #e11d48;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    box-shadow: 0 8px 16px rgba(239, 68, 68, 0.4);\n}\n\n.modal-header-premium h3 {\n    margin: 0;\n    font-size: 1.35rem;\n    font-weight: 500;\n    color: var(--text-main);\n    letter-spacing: -0.02em;\n}\n\n.close-btn-v2 {\n    position: absolute;\n    top: 1.5rem;\n    right: 1.5rem;\n    background: none;\n    border: none;\n    font-size: 2rem;\n    color: var(--text-muted);\n    cursor: pointer;\n    line-height: 1;\n}\n\n.modal-body-premium {\n    padding: 2rem;\n}\n\n.danger-notice-box {\n    background: rgba(239, 68, 68, 0.03);\n    border: 1px solid rgba(239, 68, 68, 0.1);\n    border-radius: 12px;\n    padding: 1.25rem;\n    margin-bottom: 2rem;\n}\n\n.danger-notice-box p {\n    margin: 0 0 0.5rem 0;\n    color: var(--text-main);\n    font-size: 1.05rem;\n    font-weight: 600;\n}\n\n.danger-notice-box small {\n    display: block;\n    color: var(--text-secondary);\n    line-height: 1.5;\n}\n\n.confirm-input-group-v2 {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.confirm-input-group-v2 label {\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.keyword-danger {\n    color: #e11d48;\n    /* Rose 600 */\n    text-decoration: none;\n    border-bottom: 2px solid rgba(225, 29, 72, 0.3);\n}\n\n.confirm-input-v2 {\n    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;\n    width: 100%;\n    background: var(--bg-input);\n    border: 1.5px solid var(--border-color);\n    padding: 1.1rem 1.25rem;\n    border-radius: 16px;\n    font-size: 1.05rem;\n    font-weight: 500;\n    color: #e11d48;\n    letter-spacing: 0.05em;\n    text-align: center;\n    transition: all 0.2s;\n}\n\n.confirm-input-v2:focus {\n    outline: 2px solid #e11d48;\n    border-color: transparent;\n    background: var(--surface);\n}\n\n.error-notice-box {\n    margin-top: 1.5rem;\n    padding: 1rem;\n    background: rgba(239, 68, 68, 0.1);\n    border: 1px solid rgba(239, 68, 68, 0.2);\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    color: #e11d48;\n    font-size: 0.88rem;\n    font-weight: 600;\n}\n\n.modal-footer-premium {\n    padding: 1.5rem 2rem 2rem;\n    display: flex;\n    gap: 1rem;\n    background: rgba(0, 0, 0, 0.02);\n}\n\nhtml[data-theme='dark'] .modal-footer-premium {\n    background: rgba(255, 255, 255, 0.02);\n}\n\n.btn-cancel-premium,\n.btn-danger-premium {\n    flex: 1;\n    padding: 1.1rem;\n    border-radius: 16px;\n    font-size: 0.95rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.btn-cancel-premium {\n    background: var(--surface-light);\n    color: var(--text-secondary);\n    border: 1px solid var(--border-color);\n}\n\n.btn-cancel-premium:hover {\n    background: var(--surface);\n    color: var(--text-main);\n}\n\n.btn-danger-premium {\n    border: none;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.btn-danger-premium.locked {\n    background: var(--bg-icon-wrapper);\n    color: var(--text-muted);\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n.btn-danger-premium.active {\n    background: #e11d48;\n    color: white;\n    box-shadow: 0 10px 25px rgba(225, 29, 72, 0.3);\n}\n\n.btn-danger-premium.active:hover {\n    background: #dc2626;\n    transform: translateY(-2px);\n    box-shadow: 0 15px 30px rgba(239, 68, 68, 0.4);\n}\n\n.btn-danger-premium.active:active {\n    transform: translateY(0);\n}\n\n/* --- Sliding Drawer --- */\n.drawer-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.4);\n    backdrop-filter: blur(4px);\n    z-index: 2000;\n    display: flex;\n    justify-content: flex-end;\n    opacity: 0;\n    animation: fadeIn 0.3s forwards;\n}\n\n@keyframes fadeIn {\n    to {\n        opacity: 1;\n    }\n}\n\n.drawer-panel {\n    width: 100%;\n    max-width: 650px;\n    height: 100vh;\n    background: var(--bg-primary);\n    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.2);\n    border-left: 1px solid var(--border-color);\n    transform: translateX(100%);\n    animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n}\n\nhtml[data-theme='dark'] .drawer-panel {\n    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.5);\n}\n\n@keyframes slideIn {\n    to {\n        transform: translateX(0);\n    }\n}\n\n.drawer-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.5rem 2rem;\n    border-bottom: 1px solid var(--border-glass);\n    background: var(--bg-header);\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    backdrop-filter: blur(12px);\n}\n\n.drawer-title {\n    margin: 0;\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.drawer-subtitle {\n    margin: 0;\n    font-size: 0.85rem;\n    color: var(--text-muted);\n}\n\n.drawer-close {\n    background: var(--bg-icon-wrapper);\n    border: 1px solid var(--border-color);\n    color: var(--text-muted);\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.drawer-close:hover {\n    background: rgba(239, 68, 68, 0.1);\n    color: #ef4444;\n    border-color: rgba(239, 68, 68, 0.3);\n    transform: rotate(90deg);\n}\n\n.drawer-content {\n    padding: 2rem;\n    flex: 1;\n}\n\n/* --- Beautifications for Migrations List View --- */\n\n.filter-bar {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    background: var(--bg-card);\n    border: 1px solid var(--border-glass);\n    border-radius: 12px;\n    padding: 0.6rem 1rem;\n    margin-bottom: 1.5rem;\n    max-width: 400px;\n    box-shadow: var(--shadow-soft);\n    backdrop-filter: var(--glass-blur);\n    transition: all 0.3s ease;\n}\n\n.filter-bar:focus-within {\n    border-color: var(--text-accent);\n    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.15);\n}\n\n.filter-bar svg {\n    color: var(--text-muted);\n}\n\n.filter-bar input {\n    background: transparent;\n    border: none;\n    outline: none;\n    color: var(--text-primary);\n    font-size: 0.9rem;\n    width: 100%;\n}\n\n.filter-bar input::placeholder {\n    color: var(--text-muted);\n    opacity: 0.6;\n}\n\n/* Table Hover Interactions & Column Padding */\n.dms-table tbody tr {\n    transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n.dms-table tbody tr:hover {\n    background: rgba(255, 255, 255, 0.02) !important;\n}\n\nhtml[data-theme='light'] .dms-table tbody tr:hover {\n    background: rgba(0, 0, 0, 0.015) !important;\n}\n\n.checkbox-col {\n    width: 45px;\n    padding-left: 1.5rem !important;\n    text-align: center;\n}\n\n.status-col {\n    width: 35px;\n    padding: 1.25rem 0.5rem !important;\n    text-align: center;\n}\n\n/* Job Name Link Hover Micro-interaction */\n.job-name-link {\n    font-weight: normal;\n    color: #6366f1;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: inline-block;\n    text-decoration: none;\n}\n\n.job-name-link:hover {\n    color: #818cf8;\n    text-decoration: none;\n    transform: translateX(3px);\n}\n\n/* Connection Cell Wrapper & Badges */\n.connection-cell-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    font-weight: normal;\n}\n\n.connection-cell-wrapper .connection-name {\n    color: var(--text-primary);\n    font-size: 0.9rem;\n    font-weight: normal !important;\n}\n\n.connection-cell-wrapper .engine-badge {\n    font-size: 0.65rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    padding: 2px 6px;\n    border-radius: 4px;\n    background: rgba(99, 102, 241, 0.1);\n    color: #818cf8;\n    border: 1px solid rgba(99, 102, 241, 0.2);\n    letter-spacing: 0.5px;\n}\n\n/* Status Capsules */\n.status-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.25rem 0.75rem;\n    border-radius: 9999px;\n    font-size: 0.725rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    border: 1px solid transparent;\n}\n\n.status-badge.running {\n    background: rgba(59, 130, 246, 0.1);\n    color: #3b82f6;\n    border-color: rgba(59, 130, 246, 0.2);\n}\n\n.status-badge.completed {\n    background: rgba(16, 185, 129, 0.1);\n    color: #10b981;\n    border-color: rgba(16, 185, 129, 0.2);\n}\n\n.status-badge.failed {\n    background: rgba(239, 68, 68, 0.1);\n    color: #ef4444;\n    border-color: rgba(239, 68, 68, 0.2);\n}\n\n.status-badge.stopped {\n    background: rgba(100, 116, 139, 0.1);\n    color: #94a3b8;\n    border-color: rgba(100, 116, 139, 0.2);\n}\n\n.status-badge.pending {\n    background: rgba(245, 158, 11, 0.1);\n    color: #f59e0b;\n    border-color: rgba(245, 158, 11, 0.2);\n}\n\n.status-badge.draft {\n    background: rgba(168, 85, 247, 0.1);\n    color: #a855f7;\n    border-color: rgba(168, 85, 247, 0.2);\n}\n\n/* Inactive Status Dot */\n.status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #64748b;\n    box-shadow: 0 0 4px rgba(100, 116, 139, 0.4);\n    display: inline-block;\n}\n\n/* Speed Badge */\n.speed-badge {\n    margin-left: 8px;\n    font-size: 0.725rem;\n    font-weight: 600;\n    background: rgba(16, 185, 129, 0.1);\n    color: #10b981;\n    padding: 2px 6px;\n    border-radius: 4px;\n    border: 1px solid rgba(16, 185, 129, 0.2);\n    display: inline-block;\n}\n\n/* --- Premium Beautifications for DMS Migrations Page --- */\n\n/* Custom Checkboxes */\n.dms-table input[type=\"checkbox\"],\ninput[type=\"checkbox\"].dms-checkbox {\n    -webkit-appearance: none !important;\n    appearance: none !important;\n    background-color: var(--bg-input) !important;\n    padding: 0 !important;\n    box-sizing: border-box !important;\n    margin: 0 !important;\n    font: inherit !important;\n    color: var(--text-accent) !important;\n    width: 14px !important;\n    height: 14px !important;\n    min-width: 14px !important;\n    min-height: 14px !important;\n    border: 1.5px solid var(--border-color) !important;\n    border-radius: 3.5px !important;\n    display: inline-grid !important;\n    place-content: center !important;\n    cursor: pointer !important;\n    transition: all 0.2s ease-in-out !important;\n}\n\n.dms-table input[type=\"checkbox\"]::before,\ninput[type=\"checkbox\"].dms-checkbox::before {\n    content: \"\" !important;\n    width: 8px !important;\n    height: 8px !important;\n    transform: scale(0) !important;\n    transition: 120ms transform cubic-bezier(0.34, 1.56, 0.64, 1) !important;\n    background-color: var(--text-accent) !important;\n    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%) !important;\n}\n\n.dms-table input[type=\"checkbox\"]:checked,\ninput[type=\"checkbox\"].dms-checkbox:checked {\n    border-color: var(--text-accent) !important;\n    background-color: rgba(124, 58, 237, 0.12) !important;\n}\n\n.dms-table input[type=\"checkbox\"]:checked::before,\ninput[type=\"checkbox\"].dms-checkbox:checked::before {\n    transform: scale(1) !important;\n}\n\n.dms-table input[type=\"checkbox\"]:focus,\ninput[type=\"checkbox\"].dms-checkbox:focus {\n    outline: none !important;\n    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.15) !important;\n}\n\n/* Provider Logo Uniform Frame */\n.provider-logo-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    background: var(--bg-icon-wrapper);\n    border: 1.5px solid var(--border-color);\n    padding: 6px;\n    flex-shrink: 0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.provider-logo-container:hover {\n    transform: translateY(-1px) scale(1.05);\n    border-color: var(--text-accent);\n    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.1);\n}\n\n/* Status Badges Translucency Fix (Overriding Sections.css) */\n.dms-table-container .status-badge {\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    padding: 0.35rem 0.85rem !important;\n    border-radius: 9999px !important;\n    font-size: 0.725rem !important;\n    font-weight: 700 !important;\n    text-transform: uppercase !important;\n    letter-spacing: 0.05em !important;\n    border: 1.5px solid transparent !important;\n    min-width: 95px !important;\n    box-shadow: none !important;\n    transition: all 0.2s ease !important;\n}\n\n.dms-table-container .status-badge.running {\n    background: rgba(59, 130, 246, 0.1) !important;\n    color: #3b82f6 !important;\n    border-color: rgba(59, 130, 246, 0.2) !important;\n}\n\n.dms-table-container .status-badge.completed {\n    background: rgba(16, 185, 129, 0.1) !important;\n    color: #10b981 !important;\n    border-color: rgba(16, 185, 129, 0.2) !important;\n}\n\n.dms-table-container .status-badge.failed {\n    background: rgba(239, 68, 68, 0.1) !important;\n    color: #ef4444 !important;\n    border-color: rgba(239, 68, 68, 0.2) !important;\n}\n\n.dms-table-container .status-badge.stopped {\n    background: rgba(100, 116, 139, 0.1) !important;\n    color: #64748b !important;\n    border-color: rgba(100, 116, 139, 0.2) !important;\n}\n\n.dms-table-container .status-badge.pending {\n    background: rgba(245, 158, 11, 0.1) !important;\n    color: #f59e0b !important;\n    border-color: rgba(245, 158, 11, 0.2) !important;\n}\n\n.dms-table-container .status-badge.draft {\n    background: rgba(168, 85, 247, 0.1) !important;\n    color: #a855f7 !important;\n    border-color: rgba(168, 85, 247, 0.2) !important;\n}\n\n/* Sleek Action Buttons styling */\n.dms-table .icon-btn-action {\n    height: 32px !important;\n    padding: 0 0.95rem !important;\n    border-radius: 10px !important;\n    font-size: 0.7rem !important;\n    font-weight: 700 !important;\n    gap: 6px !important;\n    border: 1.5px solid transparent !important;\n    background: transparent !important;\n    color: var(--text-muted) !important;\n    box-shadow: none !important;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.dms-table .icon-btn-action.stop {\n    color: #ef4444 !important;\n    background: rgba(239, 68, 68, 0.05) !important;\n    border-color: rgba(239, 68, 68, 0.12) !important;\n}\n\n.dms-table .icon-btn-action.stop:hover {\n    color: #ffffff !important;\n    background: #ef4444 !important;\n    border-color: #ef4444 !important;\n    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2) !important;\n    transform: translateY(-1px) !important;\n}\n\n.dms-table .icon-btn-action.cutover {\n    color: #10b981 !important;\n    background: rgba(16, 185, 129, 0.05) !important;\n    border-color: rgba(16, 185, 129, 0.12) !important;\n}\n\n.dms-table .icon-btn-action.cutover:hover {\n    color: #ffffff !important;\n    background: #10b981 !important;\n    border-color: #10b981 !important;\n    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2) !important;\n    transform: translateY(-1px) !important;\n}\n\n.dms-table .icon-btn-action.edit {\n    color: #a855f7 !important;\n    background: rgba(168, 85, 247, 0.05) !important;\n    border-color: rgba(168, 85, 247, 0.12) !important;\n}\n\n.dms-table .icon-btn-action.edit:hover {\n    color: #ffffff !important;\n    background: #a855f7 !important;\n    border-color: #a855f7 !important;\n    box-shadow: 0 4px 12px rgba(168, 85, 247, 0.2) !important;\n    transform: translateY(-1px) !important;\n}\n\n.dms-table .icon-btn-action.delete {\n    color: #ef4444 !important;\n    background: rgba(239, 68, 68, 0.05) !important;\n    border-color: rgba(239, 68, 68, 0.12) !important;\n}\n\n.dms-table .icon-btn-action.delete:hover {\n    color: #ffffff !important;\n    background: #ef4444 !important;\n    border-color: #ef4444 !important;\n    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2) !important;\n    transform: translateY(-1px) !important;\n}\n\n/* Selected Row Styles */\n.dms-table tbody tr.selected {\n    background: rgba(99, 102, 241, 0.04) !important;\n}\n\nhtml[data-theme='light'] .dms-table tbody tr.selected {\n    background: rgba(99, 102, 241, 0.03) !important;\n}\n\n.dms-table tbody tr {\n    border-left: 3px solid transparent;\n    transition: all 0.2s ease;\n}\n\n.dms-table tbody tr.selected {\n    border-left: 3px solid var(--text-accent);\n}\n\n/* Alignments and spacing */\n.dms-table th.checkbox-col,\n.dms-table td.checkbox-col {\n    text-align: center;\n    width: 60px;\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n}\n\n.dms-table th.status-col,\n.dms-table td.status-col {\n    text-align: center;\n    width: 50px;\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n}\n\n/* Centering Status Badges Column */\n.dms-table th:nth-child(4),\n.dms-table td:nth-child(4) {\n    text-align: center;\n}\n\n.dms-table td:nth-child(4) .status-cell-wrapper {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n/* Centering Actions Column */\n.dms-table th.actions-col,\n.dms-table td.actions-cell {\n    text-align: center;\n}\n\n.dms-table td.actions-cell .action-stack {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n}\n\n/* Header style and spacing */\n.dms-table thead {\n    background: rgba(0, 0, 0, 0.015);\n}\n\nhtml[data-theme='dark'] .dms-table thead {\n    background: rgba(255, 255, 255, 0.01);\n}\n\n.dms-table th {\n    font-size: 0.75rem;\n    font-weight: bold;\n    letter-spacing: 0.06em;\n    padding: 1.1rem 1rem;\n    color: #000000;\n    border-bottom: 2px solid var(--border-color);\n    text-align: center;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.test,\nhtml[data-theme=\"light\"] .btn-test {\n    background: rgba(79, 70, 229, 0.12) !important;\n    color: #4f46e5 !important;\n    border: 1px solid rgba(79, 70, 229, 0.25) !important;\n    font-weight: 700 !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.test:hover,\nhtml[data-theme=\"light\"] .btn-test:hover {\n    background: #4f46e5 !important;\n    color: white !important;\n    border-color: #4f46e5 !important;\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25) !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.edit,\nhtml[data-theme=\"light\"] .btn-edit-small {\n    background: rgba(139, 92, 246, 0.12) !important;\n    color: #7c3aed !important;\n    border: 1px solid rgba(139, 92, 246, 0.25) !important;\n    font-weight: 700 !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.edit:hover,\nhtml[data-theme=\"light\"] .btn-edit-small:hover {\n    background: #7c3aed !important;\n    color: white !important;\n    border-color: #7c3aed !important;\n    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.25) !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.delete,\nhtml[data-theme=\"light\"] .btn-delete-small {\n    background: rgba(239, 68, 68, 0.08) !important;\n    color: #dc2626 !important;\n    border: 1px solid rgba(239, 68, 68, 0.2) !important;\n    backdrop-filter: blur(4px) !important;\n    font-weight: 700 !important;\n}\n\nhtml[data-theme=\"light\"] .btn-sq-action.delete:hover,\nhtml[data-theme=\"light\"] .btn-delete-small:hover {\n    background: #dc2626 !important;\n    color: white !important;\n    border-color: #dc2626 !important;\n    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.25) !important;\n}\n\n/* --- Draft Connection Save Button styling --- */\n.btn-save-draft {\n    background: rgba(245, 158, 11, 0.08) !important;\n    border: 1px solid rgba(245, 158, 11, 0.35) !important;\n    color: #f59e0b !important;\n    font-weight: 700 !important;\n    font-size: 0.85rem !important;\n    padding: 0.6rem 1.25rem !important;\n    border-radius: 10px !important;\n    transition: all 0.3s ease !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    cursor: pointer !important;\n}\n\n.btn-save-draft:hover {\n    background: #f59e0b !important;\n    color: white !important;\n    border-color: #f59e0b !important;\n    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.25) !important;\n    transform: translateY(-1px) !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-save-draft {\n    background: rgba(245, 158, 11, 0.05) !important;\n    border: 1px solid rgba(245, 158, 11, 0.45) !important;\n    color: #fbbf24 !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-save-draft:hover {\n    background: #fbbf24 !important;\n    color: #0f172a !important;\n    border-color: #fbbf24 !important;\n    box-shadow: 0 4px 15px rgba(245, 158, 11, 0.35) !important;\n}\n\n/* --- Drafts Badge in Sidebar --- */\n.nav-draft-badge {\n    margin-left: auto;\n    background: linear-gradient(135deg, #a78bfa, #8b5cf6);\n    color: #ffffff;\n    font-size: 0.72rem;\n    font-weight: 700;\n    padding: 0.15rem 0.5rem;\n    border-radius: 9999px;\n    box-shadow: 0 0 10px rgba(167, 139, 250, 0.4);\n    min-width: 18px;\n    height: 18px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n}\n\n.dms-sidebar.collapsed .nav-draft-badge {\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    margin-left: 0;\n    font-size: 0.65rem;\n    padding: 0.1rem 0.3rem;\n    min-width: 14px;\n    height: 14px;\n}\n\n/* --- Auto-save Toast (Micro-toast) --- */\n.autosave-toast {\n    position: fixed;\n    bottom: 2rem;\n    left: 2rem;\n    z-index: 9999;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(15, 23, 42, 0.85);\n    backdrop-filter: blur(12px);\n    border: 1px solid rgba(245, 158, 11, 0.3);\n    color: #fbbf24;\n    padding: 0.5rem 0.85rem;\n    border-radius: 12px;\n    font-size: 0.82rem;\n    font-weight: 600;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3), 0 0 15px rgba(245, 158, 11, 0.15);\n    animation: autosaveToastFadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.autosave-toast-icon {\n    color: #fbbf24;\n    filter: drop-shadow(0 0 4px rgba(245, 158, 11, 0.5));\n}\n\nhtml[data-theme=\"light\"] .autosave-toast {\n    background: rgba(255, 255, 255, 0.9);\n    border-color: rgba(245, 158, 11, 0.4);\n    color: #d97706;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08), 0 0 12px rgba(245, 158, 11, 0.1);\n}\n\n@keyframes autosaveToastFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px) scale(0.95);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n/* ==========================================\n   Connection Modal Improvements (Solid & High-Contrast)\n   ========================================== */\n\n/* Modal overlay: Darker and with reduced backdrop blur (from 16px to 6px) */\n.connection-modal-overlay {\n    background: rgba(8, 10, 24, 0.82) !important;\n    backdrop-filter: blur(6px) !important;\n}\n\n/* Light mode overlay override */\nhtml[data-theme='light'] .connection-modal-overlay,\n[data-theme='light'] .connection-modal-overlay {\n    background: rgba(15, 23, 42, 0.75) !important;\n}\n\n/* Connection Modal Card: Almost fully opaque, no backdrop-filter on card itself to prevent double-blur artifacts */\n.connection-modal-card {\n    background: rgba(20, 26, 48, 0.98) !important;\n    backdrop-filter: none !important;\n    border: 1px solid rgba(168, 85, 247, 0.25) !important;\n    box-shadow: 0 25px 60px -15px rgba(0, 0, 0, 0.8),\n        0 0 40px rgba(168, 85, 247, 0.1),\n        inset 0 1px 0 0 rgba(255, 255, 255, 0.1) !important;\n}\n\n/* Light mode card override */\nhtml[data-theme='light'] .connection-modal-card,\n[data-theme='light'] .connection-modal-card {\n    background: rgba(255, 255, 255, 0.98) !important;\n    border: 1px solid rgba(124, 58, 237, 0.2) !important;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.18),\n        0 0 20px rgba(124, 58, 237, 0.05),\n        inset 0 1px 0 0 rgba(255, 255, 255, 0.9) !important;\n}\n\n/* Input Fields inside connection modal - High-contrast & solid */\n.connection-modal-card .form-group input,\n.connection-modal-card .form-group select,\n.connection-modal-card .form-group textarea {\n    background: rgba(10, 12, 24, 0.8) !important;\n    border: 1px solid rgba(255, 255, 255, 0.15) !important;\n    color: #ffffff !important;\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.25) !important;\n}\n\n.connection-modal-card .form-group input:focus,\n.connection-modal-card .form-group select:focus,\n.connection-modal-card .form-group textarea:focus {\n    background: rgba(15, 20, 38, 0.9) !important;\n    border-color: rgba(168, 85, 247, 0.6) !important;\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.25), 0 0 12px rgba(168, 85, 247, 0.3) !important;\n}\n\n/* Light mode input overrides */\nhtml[data-theme='light'] .connection-modal-card .form-group input,\nhtml[data-theme='light'] .connection-modal-card .form-group select,\nhtml[data-theme='light'] .connection-modal-card .form-group textarea,\n[data-theme='light'] .connection-modal-card .form-group input,\n[data-theme='light'] .connection-modal-card .form-group select,\n[data-theme='light'] .connection-modal-card .form-group textarea {\n    background: rgba(248, 250, 252, 0.95) !important;\n    border: 1px solid rgba(71, 85, 105, 0.3) !important;\n    color: #0f172a !important;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n\nhtml[data-theme='light'] .connection-modal-card .form-group input:focus,\nhtml[data-theme='light'] .connection-modal-card .form-group select:focus,\nhtml[data-theme='light'] .connection-modal-card .form-group textarea:focus,\n[data-theme='light'] .connection-modal-card .form-group input:focus,\n[data-theme='light'] .connection-modal-card .form-group select:focus,\n[data-theme='light'] .connection-modal-card .form-group textarea:focus {\n    background: #ffffff !important;\n    border-color: #7c3aed !important;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 8px rgba(124, 58, 237, 0.2) !important;\n}\n\n/* Labels contrast */\n.connection-modal-card .form-group label {\n    font-weight: 600 !important;\n    font-size: 0.85rem !important;\n    margin-bottom: 0.5rem !important;\n}\n\nhtml[data-theme='dark'] .connection-modal-card .form-group label,\n[data-theme='dark'] .connection-modal-card .form-group label {\n    color: #cbd5e1 !important;\n}\n\nhtml[data-theme='light'] .connection-modal-card .form-group label,\n[data-theme='light'] .connection-modal-card .form-group label {\n    color: #334155 !important;\n}\n\n/* Inner headers */\n.connection-modal-card h3,\n.connection-modal-card h4 {\n    font-weight: 700 !important;\n}\n\nhtml[data-theme='dark'] .connection-modal-card h3,\nhtml[data-theme='dark'] .connection-modal-card h4,\n[data-theme='dark'] .connection-modal-card h3,\n[data-theme='dark'] .connection-modal-card h4 {\n    color: #ffffff !important;\n}\n\nhtml[data-theme='light'] .connection-modal-card h3,\nhtml[data-theme='light'] .connection-modal-card h4,\n[data-theme='light'] .connection-modal-card h3,\n[data-theme='light'] .connection-modal-card h4 {\n    color: #0f172a !important;\n}\n\n/* ==========================================\n   Connection Wizard – Inline Form Inputs\n   ========================================== */\n\n/* Wizard inputs / selects / textareas (use inline styles for base,\n   CSS only needed for focus rings, option list colors, etc.) */\n.conn-wizard-body input,\n.conn-wizard-body select,\n.conn-wizard-body textarea {\n    font-family: inherit;\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.conn-wizard-body input:focus,\n.conn-wizard-body select:focus,\n.conn-wizard-body textarea:focus {\n    outline: none;\n    border-color: rgba(168, 85, 247, 0.6) !important;\n    box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.15) !important;\n}\n\n/* Native select option list (dark bg) */\n.conn-wizard-body select option {\n    background: #1e1e2e;\n    color: #f1f5f9;\n}\n\n/* Scrollbar for wizard body */\n.conn-wizard-scroll::-webkit-scrollbar {\n    width: 5px;\n}\n\n.conn-wizard-scroll::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.conn-wizard-scroll::-webkit-scrollbar-thumb {\n    background: rgba(139, 92, 246, 0.3);\n    border-radius: 3px;\n}\n\n/* --- Shared Unified DMS Page Header --- */\n.dms-page-container.dms-page-container {\n    padding: 0 0 5rem !important;\n    max-width: 1800px !important;\n    margin: 0 !important;\n    animation: fadeIn 0.4s ease-out;\n}\n\n.dms-page-header.dms-page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 2.5rem !important;\n    padding: 0 !important;\n    border-bottom: none !important;\n    margin: 0 0 2.5rem 0 !important;\n}\n\n.dms-page-header .header-title-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.dms-page-header .header-title-stack h2 {\n    font-family: 'Outfit', 'Plus Jakarta Sans', 'Inter', sans-serif !important;\n    font-size: 2.8rem !important;\n    font-weight: 850 !important;\n    color: var(--text-main, #f1f5f9) !important;\n    margin: 0 !important;\n    letter-spacing: -0.04em !important;\n    line-height: 1.1 !important;\n    background: var(--gradient-heading) !important;\n    -webkit-background-clip: text !important;\n    background-clip: text !important;\n    -webkit-text-fill-color: transparent !important;\n    text-align: left !important;\n}\n\n.dms-page-header .header-subtitle {\n    font-family: 'Outfit', 'Plus Jakarta Sans', 'Inter', sans-serif !important;\n    margin: 0 !important;\n    font-size: 0.95rem !important;\n    color: var(--text-secondary, #94a3b8) !important;\n    font-weight: 500 !important;\n    max-width: 600px !important;\n    text-align: left !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
